function PlanM({ ...props }) {
	return (
		<g {...props} id="unit-m">
			<g id="furniture">
				<polyline
					points="770.29 684.25 770.29 680.48 772.2 680.48 772.2 684.25 770.29 684.25"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="587.37"
					y1="728.69"
					x2="701.11"
					y2="728.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="650.2"
					y1="757.35"
					x2="645.61"
					y2="757.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.37"
					y1="742.6"
					x2="587.37"
					y2="738.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.37"
					y1="735.26"
					x2="587.37"
					y2="730.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.37"
					y1="730.59"
					x2="591.49"
					y2="730.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="594.24"
					y1="730.59"
					x2="598.83"
					y2="730.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601.58"
					y1="730.59"
					x2="606.17"
					y2="730.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="608.92"
					y1="730.59"
					x2="613.51"
					y2="730.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="616.26"
					y1="730.59"
					x2="620.85"
					y2="730.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.6"
					y1="730.59"
					x2="628.18"
					y2="730.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="630.94"
					y1="730.59"
					x2="635.52"
					y2="730.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.27"
					y1="730.59"
					x2="642.86"
					y2="730.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="645.61"
					y1="730.59"
					x2="650.2"
					y2="730.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="652.95"
					y1="730.59"
					x2="657.54"
					y2="730.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.29"
					y1="730.59"
					x2="664.88"
					y2="730.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.63"
					y1="730.59"
					x2="672.21"
					y2="730.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.97"
					y1="730.59"
					x2="679.55"
					y2="730.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="682.3"
					y1="730.59"
					x2="686.89"
					y2="730.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="689.64"
					y1="730.59"
					x2="694.23"
					y2="730.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.98"
					y1="730.59"
					x2="701.11"
					y2="730.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.11"
					y1="730.59"
					x2="701.11"
					y2="735.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.72"
					y1="540.56"
					x2="504.68"
					y2="540.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.68"
					y1="540.56"
					x2="504.68"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.68"
					y1="569.23"
					x2="503.12"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.38"
					y1="569.23"
					x2="495.79"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.03"
					y1="569.23"
					x2="488.45"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.7"
					y1="569.23"
					x2="481.11"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.36"
					y1="569.23"
					x2="473.77"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.02"
					y1="569.23"
					x2="466.43"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.68"
					y1="569.23"
					x2="459.1"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.34"
					y1="569.23"
					x2="451.76"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.01"
					y1="569.23"
					x2="444.42"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="441.67"
					y1="569.23"
					x2="437.08"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="434.33"
					y1="569.23"
					x2="429.74"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="426.99"
					y1="569.23"
					x2="422.4"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.65"
					y1="569.23"
					x2="415.06"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.31"
					y1="569.23"
					x2="407.73"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="404.97"
					y1="569.23"
					x2="400.39"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.72"
					y1="554.47"
					x2="366.72"
					y2="549.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.72"
					y1="547.13"
					x2="366.72"
					y2="542.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.72"
					y1="542.47"
					x2="368.28"
					y2="542.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.03"
					y1="542.47"
					x2="375.62"
					y2="542.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.37"
					y1="542.47"
					x2="382.96"
					y2="542.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.71"
					y1="542.47"
					x2="390.3"
					y2="542.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.05"
					y1="542.47"
					x2="397.64"
					y2="542.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="400.39"
					y1="542.47"
					x2="404.97"
					y2="542.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="407.73"
					y1="542.47"
					x2="412.31"
					y2="542.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.06"
					y1="542.47"
					x2="419.65"
					y2="542.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="422.4"
					y1="542.47"
					x2="426.99"
					y2="542.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="429.74"
					y1="542.47"
					x2="434.33"
					y2="542.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.08"
					y1="542.47"
					x2="441.67"
					y2="542.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.42"
					y1="542.47"
					x2="449.01"
					y2="542.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.76"
					y1="542.47"
					x2="456.34"
					y2="542.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.1"
					y1="542.47"
					x2="463.68"
					y2="542.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="466.43"
					y1="542.47"
					x2="471.02"
					y2="542.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.77"
					y1="542.47"
					x2="478.36"
					y2="542.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.11"
					y1="542.47"
					x2="485.7"
					y2="542.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.45"
					y1="542.47"
					x2="493.03"
					y2="542.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.79"
					y1="542.47"
					x2="500.38"
					y2="542.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.12"
					y1="542.47"
					x2="504.68"
					y2="542.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.68"
					y1="542.47"
					x2="504.68"
					y2="547.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.68"
					y1="549.89"
					x2="504.68"
					y2="554.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.68"
					y1="557.22"
					x2="504.68"
					y2="561.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.68"
					y1="564.56"
					x2="504.68"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="774.11"
					y1="693.6"
					x2="872.4"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.4"
					y1="693.6"
					x2="872.4"
					y2="568.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="501.18 702.03 552.78 702.03 552.78 753.63 501.18 753.63 501.18 702.03"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="575.36 229.48 534.42 229.48 534.42 233.61 575.36 233.61 575.36 229.48"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="532.91 229.1 576.87 229.1 576.87 229.48 532.91 229.48 532.91 229.1"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="532.91"
					y1="229.1"
					x2="576.87"
					y2="229.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.87"
					y1="229.1"
					x2="576.87"
					y2="229.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.87"
					y1="229.48"
					x2="532.91"
					y2="229.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="532.91"
					y1="229.48"
					x2="532.91"
					y2="229.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.36"
					y1="233.61"
					x2="534.42"
					y2="233.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.42"
					y1="229.48"
					x2="575.36"
					y2="229.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="578.75 233.61 575.36 233.61 575.36 229.48 578.75 229.48 578.75 233.61"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="578.75"
					y1="233.61"
					x2="575.36"
					y2="233.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.36"
					y1="233.61"
					x2="575.36"
					y2="229.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.36"
					y1="229.48"
					x2="578.75"
					y2="229.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.75"
					y1="229.48"
					x2="578.75"
					y2="233.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="531.03 229.48 534.42 229.48 534.42 233.61 531.03 233.61 531.03 229.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="531.03"
					y1="229.48"
					x2="534.42"
					y2="229.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.42"
					y1="229.48"
					x2="534.42"
					y2="233.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.42"
					y1="233.61"
					x2="531.03"
					y2="233.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.03"
					y1="233.61"
					x2="531.03"
					y2="229.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.36"
					y1="230.23"
					x2="534.42"
					y2="230.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="580.25 233.24 578.75 233.24 578.75 229.48 576.87 229.48 576.87 229.1 580.25 229.1 580.25 233.24"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="580.25"
					y1="233.24"
					x2="578.75"
					y2="233.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.75"
					y1="233.24"
					x2="578.75"
					y2="229.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.75"
					y1="229.48"
					x2="576.87"
					y2="229.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.87"
					y1="229.48"
					x2="576.87"
					y2="229.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.87"
					y1="229.1"
					x2="580.25"
					y2="229.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.25"
					y1="229.1"
					x2="580.25"
					y2="233.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="529.53 229.1 532.91 229.1 532.91 229.48 531.03 229.48 531.03 233.24 529.53 233.24 529.53 229.1"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="529.53"
					y1="229.1"
					x2="532.91"
					y2="229.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="532.91"
					y1="229.1"
					x2="532.91"
					y2="229.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="532.91"
					y1="229.48"
					x2="531.03"
					y2="229.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.03"
					y1="229.48"
					x2="531.03"
					y2="233.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.03"
					y1="233.24"
					x2="529.53"
					y2="233.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.53"
					y1="233.24"
					x2="529.53"
					y2="229.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="527.62 230.23 527.62 232.14 458.03 232.14 458.03 230.23 527.62 230.23"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="527.62"
					y1="230.23"
					x2="527.62"
					y2="232.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="527.62"
					y1="232.14"
					x2="458.03"
					y2="232.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.03"
					y1="232.14"
					x2="458.03"
					y2="230.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.03"
					y1="230.23"
					x2="527.62"
					y2="230.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="580.25 230.23 584.08 230.23 584.08 241.69 580.25 241.69 580.25 230.23"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="584.08"
					y1="230.23"
					x2="580.25"
					y2="230.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.08"
					y1="241.69"
					x2="584.08"
					y2="230.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.25"
					y1="241.69"
					x2="584.08"
					y2="241.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.25"
					y1="230.23"
					x2="580.25"
					y2="241.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="525.71 230.23 529.53 230.23 529.53 241.69 525.71 241.69 525.71 230.23"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="529.53"
					y1="230.23"
					x2="525.71"
					y2="230.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.53"
					y1="241.69"
					x2="529.53"
					y2="230.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.71"
					y1="241.69"
					x2="529.53"
					y2="241.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.71"
					y1="230.23"
					x2="525.71"
					y2="241.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="456.12 230.23 459.95 230.23 459.95 241.69 456.12 241.69 456.12 230.23"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="459.95"
					y1="230.23"
					x2="456.12"
					y2="230.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.95"
					y1="241.69"
					x2="459.95"
					y2="230.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.12"
					y1="241.69"
					x2="459.95"
					y2="241.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.12"
					y1="230.23"
					x2="456.12"
					y2="241.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="873 229.48 832.06 229.48 832.06 233.61 873 233.61 873 229.48"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="830.55 229.1 874.51 229.1 874.51 229.48 830.55 229.48 830.55 229.1"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="830.55"
					y1="229.1"
					x2="874.51"
					y2="229.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="874.51"
					y1="229.1"
					x2="874.51"
					y2="229.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="874.51"
					y1="229.48"
					x2="830.55"
					y2="229.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.55"
					y1="229.48"
					x2="830.55"
					y2="229.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="873"
					y1="233.61"
					x2="832.06"
					y2="233.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="832.06"
					y1="229.48"
					x2="873"
					y2="229.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="876.39 233.61 873 233.61 873 229.48 876.39 229.48 876.39 233.61"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="876.39"
					y1="233.61"
					x2="873"
					y2="233.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="873"
					y1="233.61"
					x2="873"
					y2="229.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="873"
					y1="229.48"
					x2="876.39"
					y2="229.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="876.39"
					y1="229.48"
					x2="876.39"
					y2="233.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="828.67 229.48 832.06 229.48 832.06 233.61 828.67 233.61 828.67 229.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="828.67"
					y1="229.48"
					x2="832.06"
					y2="229.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="832.06"
					y1="229.48"
					x2="832.06"
					y2="233.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="832.06"
					y1="233.61"
					x2="828.67"
					y2="233.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="828.67"
					y1="233.61"
					x2="828.67"
					y2="229.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="873"
					y1="230.23"
					x2="832.06"
					y2="230.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="877.89 233.24 876.39 233.24 876.39 229.48 874.51 229.48 874.51 229.1 877.89 229.1 877.89 233.24"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="877.89"
					y1="233.24"
					x2="876.39"
					y2="233.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="876.39"
					y1="233.24"
					x2="876.39"
					y2="229.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="876.39"
					y1="229.48"
					x2="874.51"
					y2="229.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="874.51"
					y1="229.48"
					x2="874.51"
					y2="229.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="874.51"
					y1="229.1"
					x2="877.89"
					y2="229.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.89"
					y1="229.1"
					x2="877.89"
					y2="233.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="827.16 229.1 830.55 229.1 830.55 229.48 828.67 229.48 828.67 233.24 827.16 233.24 827.16 229.1"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="827.16"
					y1="229.1"
					x2="830.55"
					y2="229.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.55"
					y1="229.1"
					x2="830.55"
					y2="229.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.55"
					y1="229.48"
					x2="828.67"
					y2="229.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="828.67"
					y1="229.48"
					x2="828.67"
					y2="233.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="828.67"
					y1="233.24"
					x2="827.16"
					y2="233.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="827.16"
					y1="233.24"
					x2="827.16"
					y2="229.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="825.25 230.23 825.25 232.14 734.47 232.14 734.47 230.23 825.25 230.23"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="825.25"
					y1="230.23"
					x2="825.25"
					y2="232.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825.25"
					y1="232.14"
					x2="734.47"
					y2="232.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.47"
					y1="232.14"
					x2="734.47"
					y2="230.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.47"
					y1="230.23"
					x2="825.25"
					y2="230.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="877.89 230.23 881.71 230.23 881.71 241.69 877.89 241.69 877.89 230.23"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="881.71"
					y1="230.23"
					x2="877.89"
					y2="230.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="881.71"
					y1="241.69"
					x2="881.71"
					y2="230.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.89"
					y1="241.69"
					x2="881.71"
					y2="241.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.89"
					y1="230.23"
					x2="877.89"
					y2="241.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="823.34 230.23 827.16 230.23 827.16 241.69 823.34 241.69 823.34 230.23"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="827.16"
					y1="230.23"
					x2="823.34"
					y2="230.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="827.16"
					y1="241.69"
					x2="827.16"
					y2="230.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.34"
					y1="241.69"
					x2="827.16"
					y2="241.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.34"
					y1="230.23"
					x2="823.34"
					y2="241.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="732.56 230.23 736.38 230.23 736.38 241.69 732.56 241.69 732.56 230.23"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="736.38"
					y1="230.23"
					x2="732.56"
					y2="230.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.38"
					y1="241.69"
					x2="736.38"
					y2="230.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.56"
					y1="241.69"
					x2="736.38"
					y2="241.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.56"
					y1="230.23"
					x2="732.56"
					y2="241.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.19"
					y1="772.64"
					x2="370.32"
					y2="772.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.19"
					y1="757.35"
					x2="370.32"
					y2="757.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.19"
					y1="757.35"
					x2="373.19"
					y2="772.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.81"
					y1="772.64"
					x2="448.68"
					y2="772.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.81"
					y1="757.35"
					x2="448.68"
					y2="757.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.81"
					y1="757.35"
					x2="445.81"
					y2="772.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.12"
					y1="757.35"
					x2="496.84"
					y2="757.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="444.85 773.59 448.68 773.59 448.68 772.64 444.85 772.64 444.85 773.59"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="374.14 772.64 370.32 772.64 370.32 773.59 374.14 773.59 374.14 772.64"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="444.85 757.35 448.68 757.35 448.68 756.4 444.85 756.4 444.85 757.35"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="374.14 756.4 370.32 756.4 370.32 757.35 374.14 757.35 374.14 756.4"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="444.85"
					y1="773.59"
					x2="448.68"
					y2="773.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.68"
					y1="773.59"
					x2="448.68"
					y2="772.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.68"
					y1="772.64"
					x2="444.85"
					y2="772.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.85"
					y1="772.64"
					x2="444.85"
					y2="773.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.14"
					y1="772.64"
					x2="370.32"
					y2="772.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.32"
					y1="772.64"
					x2="370.32"
					y2="773.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.32"
					y1="773.59"
					x2="374.14"
					y2="773.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.14"
					y1="773.59"
					x2="374.14"
					y2="772.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.85"
					y1="757.35"
					x2="448.68"
					y2="757.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.68"
					y1="757.35"
					x2="448.68"
					y2="756.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.68"
					y1="756.4"
					x2="444.85"
					y2="756.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.85"
					y1="756.4"
					x2="444.85"
					y2="757.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.14"
					y1="756.4"
					x2="370.32"
					y2="756.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.32"
					y1="756.4"
					x2="370.32"
					y2="757.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.32"
					y1="757.35"
					x2="374.14"
					y2="757.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="374.14"
					y1="757.35"
					x2="374.14"
					y2="756.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="443.9 772.64 445.33 772.64 445.33 757.35 443.9 757.35 443.9 772.64"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="373.67 772.64 375.1 772.64 375.1 757.35 373.67 757.35 373.67 772.64"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="423.75 708.7 375.1 757.35 377.46 759.72 426.11 711.07 423.75 708.7"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="445.33"
					y1="757.35"
					x2="445.81"
					y2="757.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.33"
					y1="772.64"
					x2="445.81"
					y2="772.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.81"
					y1="757.35"
					x2="445.81"
					y2="772.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.67"
					y1="757.35"
					x2="373.19"
					y2="757.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.67"
					y1="772.64"
					x2="373.19"
					y2="772.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.19"
					y1="757.35"
					x2="373.19"
					y2="772.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="443.9"
					y1="772.64"
					x2="443.9"
					y2="757.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="443.9"
					y1="757.35"
					x2="445.33"
					y2="757.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.33"
					y1="757.35"
					x2="445.33"
					y2="772.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.33"
					y1="772.64"
					x2="443.9"
					y2="772.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.67"
					y1="772.64"
					x2="373.67"
					y2="757.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.67"
					y1="757.35"
					x2="375.1"
					y2="757.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="375.1"
					y1="757.35"
					x2="375.1"
					y2="772.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="375.1"
					y1="772.64"
					x2="373.67"
					y2="772.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="423.75"
					y1="708.7"
					x2="426.11"
					y2="711.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="426.11"
					y1="711.07"
					x2="377.46"
					y2="759.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="377.46"
					y1="759.72"
					x2="375.1"
					y2="757.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="375.1"
					y1="757.35"
					x2="423.75"
					y2="708.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.81"
					y1="757.35"
					x2="445.81"
					y2="772.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.81"
					y1="757.35"
					x2="445.81"
					y2="772.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.81"
					y1="757.35"
					x2="448.68"
					y2="757.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.81"
					y1="757.35"
					x2="448.68"
					y2="757.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.81"
					y1="772.64"
					x2="448.68"
					y2="772.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.81"
					y1="772.64"
					x2="448.68"
					y2="772.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.19"
					y1="757.35"
					x2="373.19"
					y2="772.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.19"
					y1="757.35"
					x2="373.19"
					y2="772.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.19"
					y1="757.35"
					x2="370.32"
					y2="757.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.19"
					y1="757.35"
					x2="370.32"
					y2="757.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.19"
					y1="772.64"
					x2="370.32"
					y2="772.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.19"
					y1="772.64"
					x2="370.32"
					y2="772.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="881.71"
					y1="226.41"
					x2="881.71"
					y2="241.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="65.29"
					y1="692.98"
					x2="65.29"
					y2="578.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="774.11"
					y1="739.47"
					x2="774.11"
					y2="757.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.52"
					y1="703.15"
					x2="677.39"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.52"
					y1="693.6"
					x2="677.39"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.52"
					y1="693.6"
					x2="674.52"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.37"
					y1="703.15"
					x2="610.5"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.37"
					y1="693.6"
					x2="610.5"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.37"
					y1="693.6"
					x2="613.37"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.31"
					y1="703.15"
					x2="495.45"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.31"
					y1="693.6"
					x2="495.45"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.31"
					y1="693.6"
					x2="498.31"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.65"
					y1="703.15"
					x2="558.51"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.65"
					y1="693.6"
					x2="558.51"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.65"
					y1="693.6"
					x2="555.65"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="496.84"
					y1="703.15"
					x2="498.31"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.65"
					y1="703.15"
					x2="557.12"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.37"
					y1="703.15"
					x2="613.37"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.52"
					y1="703.15"
					x2="701.11"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.66"
					y1="693.6"
					x2="674.52"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.31"
					y1="693.6"
					x2="487.28"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="614.32 704.11 614.32 703.15 610.5 703.15 610.5 704.11 614.32 704.11"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="673.56 703.15 673.56 704.11 677.39 704.11 677.39 703.15 673.56 703.15"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="614.32 693.6 614.32 692.64 610.5 692.64 610.5 693.6 614.32 693.6"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="673.56 692.64 673.56 693.6 677.39 693.6 677.39 692.64 673.56 692.64"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="614.32"
					y1="704.11"
					x2="610.5"
					y2="704.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.5"
					y1="704.11"
					x2="610.5"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.5"
					y1="703.15"
					x2="614.32"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="614.32"
					y1="703.15"
					x2="614.32"
					y2="704.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.56"
					y1="703.15"
					x2="677.39"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="677.39"
					y1="703.15"
					x2="677.39"
					y2="704.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="677.39"
					y1="704.11"
					x2="673.56"
					y2="704.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.56"
					y1="704.11"
					x2="673.56"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="614.32"
					y1="693.6"
					x2="610.5"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.5"
					y1="693.6"
					x2="610.5"
					y2="692.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.5"
					y1="692.64"
					x2="614.32"
					y2="692.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="614.32"
					y1="692.64"
					x2="614.32"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.56"
					y1="692.64"
					x2="677.39"
					y2="692.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="677.39"
					y1="692.64"
					x2="677.39"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="677.39"
					y1="693.6"
					x2="673.56"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.56"
					y1="693.6"
					x2="673.56"
					y2="692.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="615.28 703.15 615.28 693.6 613.84 693.6 613.84 703.15 615.28 703.15"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="674.04 703.15 674.04 693.6 672.61 693.6 672.61 703.15 674.04 703.15"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="632.07 653.06 629.7 655.43 670.24 695.97 672.61 693.6 632.07 653.06"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="613.84"
					y1="693.6"
					x2="613.37"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.84"
					y1="703.15"
					x2="613.37"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.37"
					y1="693.6"
					x2="613.37"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.04"
					y1="693.6"
					x2="674.52"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.04"
					y1="703.15"
					x2="674.52"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.52"
					y1="693.6"
					x2="674.52"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="615.28"
					y1="703.15"
					x2="615.28"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="615.28"
					y1="693.6"
					x2="613.84"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.84"
					y1="693.6"
					x2="613.84"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.84"
					y1="703.15"
					x2="615.28"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.04"
					y1="703.15"
					x2="674.04"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.04"
					y1="693.6"
					x2="672.61"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="672.61"
					y1="693.6"
					x2="672.61"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="672.61"
					y1="703.15"
					x2="674.04"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="632.07"
					y1="653.06"
					x2="629.7"
					y2="655.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="629.7"
					y1="655.43"
					x2="670.24"
					y2="695.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.24"
					y1="695.97"
					x2="672.61"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="672.61"
					y1="693.6"
					x2="632.07"
					y2="653.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.37"
					y1="693.6"
					x2="613.37"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.37"
					y1="693.6"
					x2="613.37"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.37"
					y1="693.6"
					x2="610.5"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.37"
					y1="693.6"
					x2="610.5"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.37"
					y1="703.15"
					x2="610.5"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.37"
					y1="703.15"
					x2="610.5"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.52"
					y1="693.6"
					x2="674.52"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.52"
					y1="693.6"
					x2="674.52"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.52"
					y1="693.6"
					x2="677.39"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.52"
					y1="693.6"
					x2="677.39"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.52"
					y1="703.15"
					x2="677.39"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.52"
					y1="703.15"
					x2="677.39"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="554.69 704.11 558.51 704.11 558.51 703.15 554.69 703.15 554.69 704.11"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="499.27 703.15 495.45 703.15 495.45 704.11 499.27 704.11 499.27 703.15"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="554.69 693.6 558.51 693.6 558.51 692.64 554.69 692.64 554.69 693.6"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="499.27 692.64 495.45 692.64 495.45 693.6 499.27 693.6 499.27 692.64"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="554.69"
					y1="704.11"
					x2="558.51"
					y2="704.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="558.51"
					y1="704.11"
					x2="558.51"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="558.51"
					y1="703.15"
					x2="554.69"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="554.69"
					y1="703.15"
					x2="554.69"
					y2="704.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.27"
					y1="703.15"
					x2="495.45"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.45"
					y1="703.15"
					x2="495.45"
					y2="704.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.45"
					y1="704.11"
					x2="499.27"
					y2="704.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.27"
					y1="704.11"
					x2="499.27"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="554.69"
					y1="693.6"
					x2="558.51"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="558.51"
					y1="693.6"
					x2="558.51"
					y2="692.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="558.51"
					y1="692.64"
					x2="554.69"
					y2="692.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="554.69"
					y1="692.64"
					x2="554.69"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.27"
					y1="692.64"
					x2="495.45"
					y2="692.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.45"
					y1="692.64"
					x2="495.45"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.45"
					y1="693.6"
					x2="499.27"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.27"
					y1="693.6"
					x2="499.27"
					y2="692.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="553.73 703.15 555.17 703.15 555.17 693.6 553.73 693.6 553.73 703.15"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="498.79 703.15 500.23 703.15 500.23 693.6 498.79 693.6 498.79 703.15"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="538.06 655.76 500.23 693.6 502.59 695.97 540.43 658.13 538.06 655.76"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="555.17"
					y1="693.6"
					x2="555.65"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.17"
					y1="703.15"
					x2="555.65"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.65"
					y1="693.6"
					x2="555.65"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.79"
					y1="693.6"
					x2="498.31"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.79"
					y1="703.15"
					x2="498.31"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.31"
					y1="693.6"
					x2="498.31"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="553.73"
					y1="703.15"
					x2="553.73"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="553.73"
					y1="693.6"
					x2="555.17"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.17"
					y1="693.6"
					x2="555.17"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.17"
					y1="703.15"
					x2="553.73"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.79"
					y1="703.15"
					x2="498.79"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.79"
					y1="693.6"
					x2="500.23"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.23"
					y1="693.6"
					x2="500.23"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.23"
					y1="703.15"
					x2="498.79"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="538.06"
					y1="655.76"
					x2="540.43"
					y2="658.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="540.43"
					y1="658.13"
					x2="502.59"
					y2="695.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.59"
					y1="695.97"
					x2="500.23"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.23"
					y1="693.6"
					x2="538.06"
					y2="655.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.65"
					y1="693.6"
					x2="555.65"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.65"
					y1="693.6"
					x2="555.65"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.65"
					y1="693.6"
					x2="558.51"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.65"
					y1="693.6"
					x2="558.51"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.65"
					y1="703.15"
					x2="558.51"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.65"
					y1="703.15"
					x2="558.51"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.31"
					y1="693.6"
					x2="498.31"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.31"
					y1="693.6"
					x2="498.31"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.31"
					y1="693.6"
					x2="495.45"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.31"
					y1="693.6"
					x2="495.45"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.31"
					y1="703.15"
					x2="495.45"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.31"
					y1="703.15"
					x2="495.45"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.12"
					y1="703.15"
					x2="557.12"
					y2="757.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.59"
					y1="590.7"
					x2="241.59"
					y2="587.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="251.14"
					y1="651.85"
					x2="251.14"
					y2="654.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.59"
					y1="651.85"
					x2="241.59"
					y2="654.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.59"
					y1="651.85"
					x2="251.14"
					y2="651.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="252.1 650.9 251.14 650.9 251.14 654.72 252.1 654.72 252.1 650.9"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="241.59 650.9 240.63 650.9 240.63 654.72 241.59 654.72 241.59 650.9"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="240.63 591.65 241.59 591.65 241.59 587.83 240.63 587.83 240.63 591.65"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="252.1"
					y1="650.9"
					x2="252.1"
					y2="654.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="252.1"
					y1="654.72"
					x2="251.14"
					y2="654.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="251.14"
					y1="654.72"
					x2="251.14"
					y2="650.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="251.14"
					y1="650.9"
					x2="252.1"
					y2="650.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.59"
					y1="650.9"
					x2="241.59"
					y2="654.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.59"
					y1="654.72"
					x2="240.63"
					y2="654.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.63"
					y1="654.72"
					x2="240.63"
					y2="650.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.63"
					y1="650.9"
					x2="241.59"
					y2="650.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.63"
					y1="591.65"
					x2="240.63"
					y2="587.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.63"
					y1="587.83"
					x2="241.59"
					y2="587.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.59"
					y1="587.83"
					x2="241.59"
					y2="591.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.59"
					y1="591.65"
					x2="240.63"
					y2="591.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="251.14 649.94 241.59 649.94 241.59 651.37 251.14 651.37 251.14 649.94"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="201.05 633.15 203.41 635.51 243.95 594.97 241.59 592.61 201.05 633.15"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="241.59"
					y1="651.37"
					x2="241.59"
					y2="651.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="251.14"
					y1="651.37"
					x2="251.14"
					y2="651.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.59"
					y1="651.85"
					x2="251.14"
					y2="651.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.59"
					y1="591.17"
					x2="241.59"
					y2="590.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="251.14"
					y1="649.94"
					x2="241.59"
					y2="649.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.59"
					y1="649.94"
					x2="241.59"
					y2="651.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.59"
					y1="651.37"
					x2="251.14"
					y2="651.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="251.14"
					y1="651.37"
					x2="251.14"
					y2="649.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.59"
					y1="591.17"
					x2="241.59"
					y2="592.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.05"
					y1="633.15"
					x2="203.41"
					y2="635.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="203.41"
					y1="635.51"
					x2="243.95"
					y2="594.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="243.95"
					y1="594.97"
					x2="241.59"
					y2="592.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.59"
					y1="592.61"
					x2="201.05"
					y2="633.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.59"
					y1="651.85"
					x2="251.14"
					y2="651.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.59"
					y1="651.85"
					x2="251.14"
					y2="651.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.59"
					y1="651.85"
					x2="241.59"
					y2="654.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.59"
					y1="651.85"
					x2="241.59"
					y2="654.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="251.14"
					y1="651.85"
					x2="251.14"
					y2="654.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="251.14"
					y1="651.85"
					x2="251.14"
					y2="654.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.59"
					y1="590.7"
					x2="241.59"
					y2="587.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.59"
					y1="590.7"
					x2="241.59"
					y2="587.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="123.61"
					y1="717.55"
					x2="123.61"
					y2="692.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="123.61"
					y1="692.98"
					x2="65.29"
					y2="692.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.63"
					y1="578.78"
					x2="625.5"
					y2="578.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.63"
					y1="569.23"
					x2="625.5"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.63"
					y1="569.23"
					x2="622.63"
					y2="578.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.48"
					y1="578.78"
					x2="558.61"
					y2="578.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.48"
					y1="569.23"
					x2="558.61"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.48"
					y1="569.23"
					x2="561.48"
					y2="578.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="562.43 579.74 562.43 578.78 558.61 578.78 558.61 579.74 562.43 579.74"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="621.67 578.78 621.67 579.74 625.5 579.74 625.5 578.78 621.67 578.78"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="562.43 569.23 562.43 568.27 558.61 568.27 558.61 569.23 562.43 569.23"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="621.67 568.27 621.67 569.23 625.5 569.23 625.5 568.27 621.67 568.27"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="562.43"
					y1="579.74"
					x2="558.61"
					y2="579.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="558.61"
					y1="579.74"
					x2="558.61"
					y2="578.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="558.61"
					y1="578.78"
					x2="562.43"
					y2="578.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.43"
					y1="578.78"
					x2="562.43"
					y2="579.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="621.67"
					y1="578.78"
					x2="625.5"
					y2="578.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="625.5"
					y1="578.78"
					x2="625.5"
					y2="579.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="625.5"
					y1="579.74"
					x2="621.67"
					y2="579.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="621.67"
					y1="579.74"
					x2="621.67"
					y2="578.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.43"
					y1="569.23"
					x2="558.61"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="558.61"
					y1="569.23"
					x2="558.61"
					y2="568.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="558.61"
					y1="568.27"
					x2="562.43"
					y2="568.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.43"
					y1="568.27"
					x2="562.43"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="621.67"
					y1="568.27"
					x2="625.5"
					y2="568.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="625.5"
					y1="568.27"
					x2="625.5"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="625.5"
					y1="569.23"
					x2="621.67"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="621.67"
					y1="569.23"
					x2="621.67"
					y2="568.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="563.39 578.78 563.39 569.23 561.95 569.23 561.95 578.78 563.39 578.78"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="622.15 578.78 622.15 569.23 620.72 569.23 620.72 578.78 622.15 578.78"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="580.18 528.69 577.81 531.05 618.35 571.59 620.72 569.23 580.18 528.69"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="561.95"
					y1="569.23"
					x2="561.48"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.95"
					y1="578.78"
					x2="561.48"
					y2="578.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.48"
					y1="569.23"
					x2="561.48"
					y2="578.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.15"
					y1="569.23"
					x2="622.63"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.15"
					y1="578.78"
					x2="622.63"
					y2="578.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.63"
					y1="569.23"
					x2="622.63"
					y2="578.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.39"
					y1="578.78"
					x2="563.39"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.39"
					y1="569.23"
					x2="561.95"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.95"
					y1="569.23"
					x2="561.95"
					y2="578.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.95"
					y1="578.78"
					x2="563.39"
					y2="578.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.15"
					y1="578.78"
					x2="622.15"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.15"
					y1="569.23"
					x2="620.72"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.72"
					y1="569.23"
					x2="620.72"
					y2="578.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.72"
					y1="578.78"
					x2="622.15"
					y2="578.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.18"
					y1="528.69"
					x2="577.81"
					y2="531.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.81"
					y1="531.05"
					x2="618.35"
					y2="571.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="618.35"
					y1="571.59"
					x2="620.72"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.72"
					y1="569.23"
					x2="580.18"
					y2="528.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.48"
					y1="569.23"
					x2="561.48"
					y2="578.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.48"
					y1="569.23"
					x2="561.48"
					y2="578.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.48"
					y1="569.23"
					x2="558.61"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.48"
					y1="569.23"
					x2="558.61"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.48"
					y1="578.78"
					x2="558.61"
					y2="578.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.48"
					y1="578.78"
					x2="558.61"
					y2="578.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.63"
					y1="569.23"
					x2="622.63"
					y2="578.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.63"
					y1="569.23"
					x2="622.63"
					y2="578.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.63"
					y1="569.23"
					x2="625.5"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.63"
					y1="569.23"
					x2="625.5"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.63"
					y1="578.78"
					x2="625.5"
					y2="578.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.63"
					y1="578.78"
					x2="625.5"
					y2="578.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.24"
					y1="569.23"
					x2="514.24"
					y2="515.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.68"
					y1="525.22"
					x2="504.68"
					y2="569.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.49"
					y1="525.22"
					x2="388.11"
					y2="525.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.49"
					y1="523.31"
					x2="390.49"
					y2="525.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.49"
					y1="515.66"
					x2="388.11"
					y2="515.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.49"
					y1="515.66"
					x2="390.49"
					y2="523.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.4"
					y1="525.22"
					x2="482.79"
					y2="525.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.4"
					y1="523.31"
					x2="480.4"
					y2="525.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.4"
					y1="515.66"
					x2="482.79"
					y2="515.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.4"
					y1="515.66"
					x2="480.4"
					y2="523.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.24"
					y1="515.66"
					x2="480.4"
					y2="515.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.49"
					y1="515.66"
					x2="366.72"
					y2="515.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.72"
					y1="525.22"
					x2="390.49"
					y2="525.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.4"
					y1="525.22"
					x2="504.68"
					y2="525.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="478.97 523.31 478.97 525.22 479.92 525.22 479.92 523.31 478.97 523.31"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="478.97 526.17 482.79 526.17 482.79 525.22 478.97 525.22 478.97 526.17"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="390.97 523.31 390.97 525.22 391.93 525.22 391.93 523.31 390.97 523.31"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="391.93 525.22 388.11 525.22 388.11 526.17 391.93 526.17 391.93 525.22"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="478.97 515.66 482.79 515.66 482.79 513.27 478.97 513.27 478.97 515.66"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="391.93 513.27 388.11 513.27 388.11 515.66 391.93 515.66 391.93 513.27"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="478.97"
					y1="523.31"
					x2="478.97"
					y2="525.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.97"
					y1="525.22"
					x2="479.92"
					y2="525.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.92"
					y1="525.22"
					x2="479.92"
					y2="523.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.92"
					y1="523.31"
					x2="478.97"
					y2="523.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.97"
					y1="526.17"
					x2="482.79"
					y2="526.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.79"
					y1="526.17"
					x2="482.79"
					y2="525.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.79"
					y1="525.22"
					x2="478.97"
					y2="525.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.97"
					y1="525.22"
					x2="478.97"
					y2="526.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.97"
					y1="523.31"
					x2="390.97"
					y2="525.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.97"
					y1="525.22"
					x2="391.93"
					y2="525.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="391.93"
					y1="525.22"
					x2="391.93"
					y2="523.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="391.93"
					y1="523.31"
					x2="390.97"
					y2="523.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="391.93"
					y1="525.22"
					x2="388.11"
					y2="525.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="388.11"
					y1="525.22"
					x2="388.11"
					y2="526.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="388.11"
					y1="526.17"
					x2="391.93"
					y2="526.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="391.93"
					y1="526.17"
					x2="391.93"
					y2="525.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.97"
					y1="515.66"
					x2="482.79"
					y2="515.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.79"
					y1="515.66"
					x2="482.79"
					y2="513.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.79"
					y1="513.27"
					x2="478.97"
					y2="513.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.97"
					y1="513.27"
					x2="478.97"
					y2="515.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="391.93"
					y1="513.27"
					x2="388.11"
					y2="513.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="388.11"
					y1="513.27"
					x2="388.11"
					y2="515.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="388.11"
					y1="515.66"
					x2="391.93"
					y2="515.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="391.93"
					y1="515.66"
					x2="391.93"
					y2="513.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="476.1 523.31 479.92 523.31 479.92 515.66 476.1 515.66 476.1 523.31"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="390.97 523.31 394.8 523.31 394.8 515.66 390.97 515.66 390.97 523.31"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="437.36 515.66 394.8 515.66 394.8 519.01 437.36 519.01 437.36 515.66"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="453.17 519.01 410.61 519.01 410.61 522.35 453.17 522.35 453.17 519.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="479.92"
					y1="515.66"
					x2="480.4"
					y2="515.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.92"
					y1="523.31"
					x2="480.4"
					y2="523.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.4"
					y1="515.66"
					x2="480.4"
					y2="523.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.97"
					y1="515.66"
					x2="390.49"
					y2="515.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.97"
					y1="523.31"
					x2="390.49"
					y2="523.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.49"
					y1="515.66"
					x2="390.49"
					y2="523.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="476.1"
					y1="523.31"
					x2="476.1"
					y2="515.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="476.1"
					y1="515.66"
					x2="479.92"
					y2="515.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.92"
					y1="515.66"
					x2="479.92"
					y2="523.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.92"
					y1="523.31"
					x2="476.1"
					y2="523.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.97"
					y1="523.31"
					x2="390.97"
					y2="515.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.97"
					y1="515.66"
					x2="394.8"
					y2="515.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.8"
					y1="515.66"
					x2="394.8"
					y2="523.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.8"
					y1="523.31"
					x2="390.97"
					y2="523.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.36"
					y1="515.66"
					x2="437.36"
					y2="519.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.36"
					y1="519.01"
					x2="394.8"
					y2="519.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.8"
					y1="519.01"
					x2="394.8"
					y2="515.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.8"
					y1="515.66"
					x2="437.36"
					y2="515.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.17"
					y1="519.01"
					x2="453.17"
					y2="522.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.17"
					y1="522.35"
					x2="410.61"
					y2="522.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="410.61"
					y1="522.35"
					x2="410.61"
					y2="519.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="410.61"
					y1="519.01"
					x2="453.17"
					y2="519.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.4"
					y1="515.66"
					x2="480.4"
					y2="523.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.4"
					y1="515.66"
					x2="480.4"
					y2="523.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.4"
					y1="523.31"
					x2="480.4"
					y2="525.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.4"
					y1="515.66"
					x2="482.79"
					y2="515.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.4"
					y1="523.31"
					x2="480.4"
					y2="525.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.4"
					y1="525.22"
					x2="482.79"
					y2="525.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.4"
					y1="525.22"
					x2="482.79"
					y2="525.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.49"
					y1="515.66"
					x2="390.49"
					y2="523.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.49"
					y1="515.66"
					x2="390.49"
					y2="523.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.49"
					y1="523.31"
					x2="390.49"
					y2="525.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.49"
					y1="515.66"
					x2="388.11"
					y2="515.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.49"
					y1="523.31"
					x2="390.49"
					y2="525.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.49"
					y1="525.22"
					x2="388.11"
					y2="525.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.49"
					y1="525.22"
					x2="388.11"
					y2="525.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.08"
					y1="226.41"
					x2="584.08"
					y2="241.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.08"
					y1="241.69"
					x2="589.77"
					y2="241.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.56"
					y1="241.69"
					x2="732.56"
					y2="226.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.12"
					y1="241.69"
					x2="456.12"
					y2="226.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="65.29 692.98 123.61 692.98 123.61 578.78 65.29 578.78 65.29 692.98"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="65.29"
					y1="578.78"
					x2="65.29"
					y2="692.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="123.61"
					y1="578.78"
					x2="65.29"
					y2="578.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="123.61"
					y1="692.98"
					x2="123.61"
					y2="578.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="65.29"
					y1="692.98"
					x2="123.61"
					y2="692.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="72.19 685.83 115.94 685.83 115.94 586.43 72.19 586.43 72.19 685.83"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="72.19"
					y1="586.43"
					x2="72.19"
					y2="685.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="115.94"
					y1="586.43"
					x2="72.19"
					y2="586.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="115.94"
					y1="685.83"
					x2="115.94"
					y2="586.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="72.19"
					y1="685.83"
					x2="115.94"
					y2="685.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="94.45 676.06 94.06 676.1 93.68 676.19 93.32 676.36 93 676.57 92.72 676.84 92.49 677.15 92.32 677.5 92.22 677.87 92.19 678.25 92.22 678.62 92.32 678.99 92.49 679.34 92.72 679.65 93 679.92 93.32 680.13 93.68 680.29 94.06 680.39 94.45 680.42 94.84 680.39 95.22 680.29 95.58 680.13 95.9 679.92 96.18 679.65 96.41 679.34 96.57 678.99 96.68 678.62 96.71 678.25 96.68 677.87 96.57 677.5 96.41 677.15 96.18 676.84 95.9 676.57 95.58 676.36 95.22 676.19 94.84 676.1 94.45 676.06"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="94.84"
					y1="676.1"
					x2="94.45"
					y2="676.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="95.22"
					y1="676.19"
					x2="94.84"
					y2="676.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="95.58"
					y1="676.36"
					x2="95.22"
					y2="676.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="95.9"
					y1="676.57"
					x2="95.58"
					y2="676.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="96.18"
					y1="676.84"
					x2="95.9"
					y2="676.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="96.41"
					y1="677.15"
					x2="96.18"
					y2="676.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="96.57"
					y1="677.5"
					x2="96.41"
					y2="677.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="96.68"
					y1="677.87"
					x2="96.57"
					y2="677.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="96.71"
					y1="678.25"
					x2="96.68"
					y2="677.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="96.68"
					y1="678.62"
					x2="96.71"
					y2="678.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="96.57"
					y1="678.99"
					x2="96.68"
					y2="678.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="96.41"
					y1="679.34"
					x2="96.57"
					y2="678.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="96.18"
					y1="679.65"
					x2="96.41"
					y2="679.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="95.9"
					y1="679.92"
					x2="96.18"
					y2="679.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="95.58"
					y1="680.13"
					x2="95.9"
					y2="679.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="95.22"
					y1="680.29"
					x2="95.58"
					y2="680.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="94.84"
					y1="680.39"
					x2="95.22"
					y2="680.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="94.45"
					y1="680.42"
					x2="94.84"
					y2="680.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="94.06"
					y1="680.39"
					x2="94.45"
					y2="680.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="93.68"
					y1="680.29"
					x2="94.06"
					y2="680.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="93.32"
					y1="680.13"
					x2="93.68"
					y2="680.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="93"
					y1="679.92"
					x2="93.32"
					y2="680.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="92.72"
					y1="679.65"
					x2="93"
					y2="679.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="92.49"
					y1="679.34"
					x2="92.72"
					y2="679.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="92.32"
					y1="678.99"
					x2="92.49"
					y2="679.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="92.22"
					y1="678.62"
					x2="92.32"
					y2="678.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="92.19"
					y1="678.25"
					x2="92.22"
					y2="678.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="92.22"
					y1="677.87"
					x2="92.19"
					y2="678.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="92.32"
					y1="677.5"
					x2="92.22"
					y2="677.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="92.49"
					y1="677.15"
					x2="92.32"
					y2="677.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="92.72"
					y1="676.84"
					x2="92.49"
					y2="677.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="93"
					y1="676.57"
					x2="92.72"
					y2="676.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="93.32"
					y1="676.36"
					x2="93"
					y2="676.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="93.68"
					y1="676.19"
					x2="93.32"
					y2="676.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="94.06"
					y1="676.1"
					x2="93.68"
					y2="676.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="94.45"
					y1="676.06"
					x2="94.06"
					y2="676.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="96.4 688.38 96.37 688.71 96.28 689.03 96.14 689.32 95.94 689.59 95.7 689.82 95.42 690.02 95.12 690.15 94.79 690.24 94.45 690.27 94.11 690.24 93.78 690.15 93.47 690.02 93.19 689.82 92.95 689.59 92.76 689.32 92.62 689.03 92.53 688.71 92.5 688.38 92.81 685.23 92.85 684.97 92.94 684.74 93.07 684.51 93.58 680.53 93.61 680.39 93.67 680.25 93.75 680.13 93.84 680.02 93.96 679.93 94.09 679.86 94.23 679.82 94.37 679.79 94.52 679.79 94.67 679.82 94.81 679.86 94.94 679.93 95.05 680.02 95.15 680.13 95.23 680.25 95.28 680.39 95.32 680.53 95.83 684.51 95.96 684.74 96.04 684.97 96.09 685.23 96.4 688.38"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="96.4"
					y1="688.38"
					x2="96.09"
					y2="685.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="95.83"
					y1="684.51"
					x2="95.32"
					y2="680.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="93.58"
					y1="680.53"
					x2="93.07"
					y2="684.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="92.81"
					y1="685.23"
					x2="92.5"
					y2="688.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="93.39"
					y1="686.51"
					x2="93.39"
					y2="685.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="95.51"
					y1="685.39"
					x2="95.51"
					y2="686.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="95.51"
					y1="686.51"
					x2="93.39"
					y2="686.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m95.83,684.51c.14.22.23.46.26.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m93.58,680.53c.05-.42.43-.74.87-.74s.81.32.87.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m92.81,685.23c.02-.25.11-.5.26-.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m96.4,688.38c0,1.04-.87,1.88-1.95,1.88s-1.95-.84-1.95-1.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m93.39,685.39c0-.56.48-1.02,1.06-1.02s1.06.46,1.06,1.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m93.07,684.51c.3-.45.82-.73,1.38-.73s1.08.27,1.38.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="172.49 679.34 123.61 679.34 123.61 717.55 172.49 717.55 172.49 679.34"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="172.49"
					y1="679.34"
					x2="123.61"
					y2="679.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="172.49"
					y1="717.55"
					x2="123.61"
					y2="717.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="123.61"
					y1="679.34"
					x2="123.61"
					y2="717.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="172.49"
					y1="679.34"
					x2="172.49"
					y2="717.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="172.49"
					y1="716.04"
					x2="123.61"
					y2="716.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="167.16"
					y1="688.41"
					x2="128.94"
					y2="688.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="128.94"
					y1="688.41"
					x2="128.94"
					y2="711.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="128.94"
					y1="711.34"
					x2="167.16"
					y2="711.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="167.16"
					y1="711.34"
					x2="167.16"
					y2="688.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="168.67"
					y1="686.91"
					x2="127.44"
					y2="686.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="127.44"
					y1="686.91"
					x2="127.44"
					y2="712.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="127.44"
					y1="712.85"
					x2="168.67"
					y2="712.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="168.67"
					y1="712.85"
					x2="168.67"
					y2="686.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m150.31,706.17c0-1.25-1.01-2.26-2.26-2.26s-2.26,1.01-2.26,2.26,1.01,2.26,2.26,2.26,2.26-1.01,2.26-2.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="149.93 715.48 149.63 712.32 149.39 711.61 148.89 707.62 148.61 707.1 148.05 706.89 147.49 707.1 147.22 707.62 146.72 711.61 146.47 712.32 146.17 715.48 146.53 716.59 147.47 717.27 148.63 717.27 149.57 716.59 149.93 715.48"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m149.93,715.48c0,1.04-.84,1.88-1.88,1.88s-1.88-.84-1.88-1.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="146.47"
					y1="712.32"
					x2="146.17"
					y2="715.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m146.47,712.32c.02-.25.11-.5.25-.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="147.22"
					y1="707.62"
					x2="146.72"
					y2="711.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m147.22,707.62c.05-.42.41-.74.84-.74s.78.32.84.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="149.39"
					y1="711.61"
					x2="148.89"
					y2="707.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m149.39,711.61c.14.22.22.46.25.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="149.93"
					y1="715.48"
					x2="149.63"
					y2="712.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="147.03"
					y1="713.61"
					x2="147.03"
					y2="712.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="149.07"
					y1="712.49"
					x2="149.07"
					y2="713.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="149.07"
					y1="713.61"
					x2="147.03"
					y2="713.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m147.03,712.49c0-.56.46-1.02,1.02-1.02s1.02.46,1.02,1.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m146.72,711.61c.29-.45.79-.73,1.33-.73s1.04.27,1.33.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="197.68 667.36 195.43 669.29 193.73 671.71 192.47 674.49 191.56 677.4 190.89 680.94 190.81 684.54 191.33 688.11 192.43 691.54 192.44 694.67 191.91 697.74 190.86 700.69 189.32 703.4 188.18 705.21 187.3 707.16 186.91 709.55 186.91 710.01 187.42 712.35 188.6 714.43 190.34 716.08 192.49 717.15 194.86 717.55 214.71 717.55 216.72 717.25 218.6 716.51 220.27 715.37 220.27 717.06 221.82 717.06 221.82 713.35 222.36 711.96 222.64 709.61 222.29 707.27 221.33 705.11 220.31 703.49 218.75 700.74 217.69 697.77 217.16 694.65 217.17 691.5 218.25 688.07 218.76 684.52 218.68 680.93 218.01 677.4 217.11 674.49 215.85 671.71 214.14 669.29 211.9 667.36 209.67 666.24 207.27 665.55 204.79 665.31 202.3 665.55 199.91 666.24 197.68 667.36"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="211.86"
					y1="699.9"
					x2="197.71"
					y2="699.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.86"
					y1="717.55"
					x2="204.79"
					y2="717.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.86"
					y1="716.83"
					x2="204.79"
					y2="716.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.71"
					y1="717.55"
					x2="204.79"
					y2="717.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.71"
					y1="716.83"
					x2="204.79"
					y2="716.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.08"
					y1="699.9"
					x2="198.08"
					y2="702.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.08"
					y1="702.54"
					x2="200.27"
					y2="702.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="200.27"
					y1="702.54"
					x2="200.27"
					y2="699.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.49"
					y1="699.9"
					x2="211.49"
					y2="702.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.49"
					y1="702.54"
					x2="209.31"
					y2="702.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.31"
					y1="702.54"
					x2="209.31"
					y2="699.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.27"
					y1="710.49"
					x2="220.27"
					y2="717.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.82"
					y1="710.49"
					x2="221.82"
					y2="717.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.82"
					y1="717.06"
					x2="220.27"
					y2="717.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.82"
					y1="710.49"
					x2="220.27"
					y2="710.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="204.79"
					y1="665.31"
					x2="202.42"
					y2="665.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="202.42"
					y1="665.58"
					x2="200.12"
					y2="666.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="200.12"
					y1="666.19"
					x2="197.68"
					y2="667.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.68"
					y1="667.36"
					x2="195.43"
					y2="669.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.43"
					y1="669.29"
					x2="193.73"
					y2="671.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.73"
					y1="671.71"
					x2="192.47"
					y2="674.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.47"
					y1="674.47"
					x2="191.56"
					y2="677.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.56"
					y1="677.4"
					x2="190.74"
					y2="682.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="190.74"
					y1="682.13"
					x2="190.69"
					y2="684.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="190.69"
					y1="684.52"
					x2="190.96"
					y2="686.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="190.96"
					y1="686.9"
					x2="192.04"
					y2="690.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.04"
					y1="690.59"
					x2="193.71"
					y2="694.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.71"
					y1="694.16"
					x2="195.7"
					y2="697.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.7"
					y1="697.35"
					x2="197.71"
					y2="699.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.43"
					y1="691.54"
					x2="192.41"
					y2="694.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.41"
					y1="694.86"
					x2="191.86"
					y2="698.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.86"
					y1="698.08"
					x2="190.49"
					y2="701.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="190.49"
					y1="701.54"
					x2="187.49"
					y2="706.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="187.49"
					y1="706.63"
					x2="186.92"
					y2="709.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="186.92"
					y1="709.16"
					x2="187.14"
					y2="711.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="187.14"
					y1="711.68"
					x2="188.12"
					y2="713.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.12"
					y1="713.97"
					x2="189.85"
					y2="715.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.85"
					y1="715.82"
					x2="191.55"
					y2="716.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.55"
					y1="716.76"
					x2="193.17"
					y2="717.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.17"
					y1="717.28"
					x2="194.86"
					y2="717.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.86"
					y1="716.83"
					x2="192.54"
					y2="716.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.54"
					y1="716.27"
					x2="191.16"
					y2="715.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.16"
					y1="715.11"
					x2="190.3"
					y2="713.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="190.3"
					y1="713.49"
					x2="189.89"
					y2="711.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.89"
					y1="711.36"
					x2="189.79"
					y2="709.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.79"
					y1="709.17"
					x2="189.81"
					y2="708.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.81"
					y1="708.07"
					x2="190.27"
					y2="707.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="190.27"
					y1="707.21"
					x2="190.81"
					y2="706.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="190.81"
					y1="706.96"
					x2="196.81"
					y2="705.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.81"
					y1="705.25"
					x2="199.8"
					y2="704.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.8"
					y1="704.74"
					x2="202.81"
					y2="704.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="202.81"
					y1="704.52"
					x2="204.79"
					y2="704.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.17"
					y1="691.5"
					x2="217.19"
					y2="694.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.19"
					y1="694.82"
					x2="217.73"
					y2="698.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.73"
					y1="698.06"
					x2="219.08"
					y2="701.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.08"
					y1="701.54"
					x2="222.09"
					y2="706.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.09"
					y1="706.63"
					x2="222.55"
					y2="708.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.55"
					y1="708.32"
					x2="222.66"
					y2="710.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.66"
					y1="710.06"
					x2="222.42"
					y2="711.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.42"
					y1="711.76"
					x2="221.82"
					y2="713.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.71"
					y1="716.83"
					x2="217.03"
					y2="716.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.03"
					y1="716.27"
					x2="218.41"
					y2="715.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.41"
					y1="715.11"
					x2="219.28"
					y2="713.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.28"
					y1="713.49"
					x2="219.69"
					y2="711.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.69"
					y1="711.36"
					x2="219.78"
					y2="709.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.78"
					y1="709.17"
					x2="219.77"
					y2="708.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.77"
					y1="708.07"
					x2="219.31"
					y2="707.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.31"
					y1="707.21"
					x2="218.77"
					y2="706.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.77"
					y1="706.96"
					x2="212.76"
					y2="705.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.76"
					y1="705.25"
					x2="209.78"
					y2="704.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.78"
					y1="704.74"
					x2="206.76"
					y2="704.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.76"
					y1="704.52"
					x2="204.79"
					y2="704.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="204.79"
					y1="665.31"
					x2="207.16"
					y2="665.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.16"
					y1="665.58"
					x2="209.45"
					y2="666.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.45"
					y1="666.19"
					x2="211.9"
					y2="667.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.9"
					y1="667.36"
					x2="214.14"
					y2="669.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.14"
					y1="669.29"
					x2="215.85"
					y2="671.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.85"
					y1="671.71"
					x2="217.1"
					y2="674.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.1"
					y1="674.47"
					x2="218.01"
					y2="677.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.01"
					y1="677.4"
					x2="218.84"
					y2="682.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.84"
					y1="682.13"
					x2="218.88"
					y2="684.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.88"
					y1="684.52"
					x2="218.61"
					y2="686.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.61"
					y1="686.9"
					x2="217.54"
					y2="690.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.54"
					y1="690.59"
					x2="215.87"
					y2="694.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.87"
					y1="694.16"
					x2="213.88"
					y2="697.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.88"
					y1="697.35"
					x2="211.86"
					y2="699.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.15"
					y1="705.25"
					x2="188.53"
					y2="704.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.53"
					y1="704.72"
					x2="189.62"
					y2="703.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.62"
					y1="703.91"
					x2="190.57"
					y2="703.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="190.57"
					y1="703.72"
					x2="196.67"
					y2="703.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.67"
					y1="703.2"
					x2="202.79"
					y2="702.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="202.79"
					y1="702.96"
					x2="204.79"
					y2="702.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.42"
					y1="705.25"
					x2="221.04"
					y2="704.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.04"
					y1="704.72"
					x2="219.95"
					y2="703.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.95"
					y1="703.91"
					x2="219"
					y2="703.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219"
					y1="703.72"
					x2="212.9"
					y2="703.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.9"
					y1="703.2"
					x2="206.79"
					y2="702.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.79"
					y1="702.96"
					x2="204.79"
					y2="702.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.27"
					y1="715.37"
					x2="219.72"
					y2="715.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.72"
					y1="715.82"
					x2="218.03"
					y2="716.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.03"
					y1="716.75"
					x2="216.41"
					y2="717.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.41"
					y1="717.28"
					x2="214.71"
					y2="717.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="185.68"
					y1="716.78"
					x2="185.68"
					y2="717.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="227.72 717.55 223.9 717.55 223.9 716.78 227.72 716.78 227.72 717.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="227.72"
					y1="717.55"
					x2="223.9"
					y2="717.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.9"
					y1="717.55"
					x2="223.9"
					y2="716.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.9"
					y1="716.78"
					x2="227.72"
					y2="716.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.72"
					y1="716.78"
					x2="227.72"
					y2="717.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="184.15"
					y1="710.56"
					x2="184.15"
					y2="716.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="226.19 716.78 225.43 716.78 225.43 710.56 226.19 710.56 226.19 716.78"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="226.19"
					y1="716.78"
					x2="225.43"
					y2="716.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.43"
					y1="716.78"
					x2="225.43"
					y2="710.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.43"
					y1="710.56"
					x2="226.19"
					y2="710.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.19"
					y1="710.56"
					x2="226.19"
					y2="716.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="184.15 712.47 184.15 710.94 225.43 710.94 225.43 712.47 184.15 712.47"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="184.15"
					y1="712.47"
					x2="184.15"
					y2="710.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="184.15"
					y1="710.94"
					x2="225.43"
					y2="710.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.43"
					y1="710.94"
					x2="225.43"
					y2="712.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.43"
					y1="712.47"
					x2="184.15"
					y2="712.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.66"
					y1="684.25"
					x2="774.11"
					y2="684.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="774.11"
					y1="684.25"
					x2="774.11"
					y2="755.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.66"
					y1="689.03"
					x2="774.11"
					y2="689.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="872.4 614.09 916.01 614.09 916.01 571.23 872.4 571.23 872.4 614.09"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="872.4"
					y1="571.23"
					x2="872.4"
					y2="572.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.4"
					y1="575.69"
					x2="872.4"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.4"
					y1="583.02"
					x2="872.4"
					y2="587.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.4"
					y1="590.37"
					x2="872.4"
					y2="594.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.4"
					y1="597.7"
					x2="872.4"
					y2="602.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.4"
					y1="605.04"
					x2="872.4"
					y2="609.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.4"
					y1="612.38"
					x2="872.4"
					y2="614.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="916.01"
					y1="571.23"
					x2="913.93"
					y2="571.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.17"
					y1="571.23"
					x2="906.59"
					y2="571.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="903.84"
					y1="571.23"
					x2="899.25"
					y2="571.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="896.49"
					y1="571.23"
					x2="891.91"
					y2="571.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="889.16"
					y1="571.23"
					x2="884.57"
					y2="571.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="881.82"
					y1="571.23"
					x2="877.23"
					y2="571.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="874.48"
					y1="571.23"
					x2="872.4"
					y2="571.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="916.01"
					y1="614.09"
					x2="916.01"
					y2="612.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="916.01"
					y1="609.63"
					x2="916.01"
					y2="605.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="916.01"
					y1="602.29"
					x2="916.01"
					y2="597.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="916.01"
					y1="594.95"
					x2="916.01"
					y2="590.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="916.01"
					y1="587.61"
					x2="916.01"
					y2="583.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="916.01"
					y1="580.28"
					x2="916.01"
					y2="575.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="916.01"
					y1="572.93"
					x2="916.01"
					y2="571.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.4"
					y1="614.09"
					x2="874.48"
					y2="614.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.23"
					y1="614.09"
					x2="881.82"
					y2="614.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.57"
					y1="614.09"
					x2="889.16"
					y2="614.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="891.91"
					y1="614.09"
					x2="896.49"
					y2="614.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="899.25"
					y1="614.09"
					x2="903.84"
					y2="614.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.59"
					y1="614.09"
					x2="911.17"
					y2="614.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="913.93"
					y1="614.09"
					x2="916.01"
					y2="614.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="870.14 571.39 868.82 571.39 868.82 613.92 870.14 613.92 870.14 607.25 869.06 607.25 869.06 578.06 870.14 578.06 870.14 571.39"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="870.14"
					y1="578.06"
					x2="870.14"
					y2="571.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="869.06"
					y1="578.06"
					x2="870.14"
					y2="578.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="869.06"
					y1="607.25"
					x2="869.06"
					y2="578.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="870.14"
					y1="607.25"
					x2="869.06"
					y2="607.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="870.14"
					y1="613.92"
					x2="870.14"
					y2="607.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="868.82"
					y1="613.92"
					x2="870.14"
					y2="613.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="868.82"
					y1="571.39"
					x2="868.82"
					y2="613.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="870.14"
					y1="571.39"
					x2="868.82"
					y2="571.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<polyline
					points="870.14 569.73 870.14 615.59 872.4 615.59 872.4 569.73 870.14 569.73"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="872.4"
					y1="569.73"
					x2="870.14"
					y2="569.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="872.4"
					y1="615.59"
					x2="872.4"
					y2="569.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="870.14"
					y1="615.59"
					x2="872.4"
					y2="615.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="870.14"
					y1="569.73"
					x2="870.14"
					y2="615.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="870.14"
					y1="613.92"
					x2="868.82"
					y2="613.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="868.82"
					y1="613.92"
					x2="868.82"
					y2="571.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="868.82"
					y1="571.39"
					x2="870.14"
					y2="571.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.14"
					y1="615.59"
					x2="870.14"
					y2="569.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.14"
					y1="578.06"
					x2="869.06"
					y2="578.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="869.06"
					y1="578.06"
					x2="869.06"
					y2="607.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="869.06"
					y1="607.25"
					x2="870.14"
					y2="607.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.4"
					y1="615.59"
					x2="870.14"
					y2="615.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.14"
					y1="569.73"
					x2="872.4"
					y2="569.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.4"
					y1="569.73"
					x2="872.4"
					y2="615.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="848.69 689.78 791.36 689.78 791.36 739.47 848.69 739.47 848.69 689.78"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="848.69"
					y1="689.78"
					x2="791.36"
					y2="689.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="848.69"
					y1="739.47"
					x2="791.36"
					y2="739.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="848.69"
					y1="737.96"
					x2="791.36"
					y2="737.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="848.69"
					y1="689.78"
					x2="848.69"
					y2="739.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="791.36"
					y1="689.78"
					x2="791.36"
					y2="739.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="844.93"
					y1="692.04"
					x2="795.12"
					y2="692.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="795.12"
					y1="692.04"
					x2="793.61"
					y2="693.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.61"
					y1="693.54"
					x2="793.61"
					y2="735.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.61"
					y1="735.7"
					x2="795.12"
					y2="737.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="795.12"
					y1="737.21"
					x2="844.93"
					y2="737.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="844.93"
					y1="737.21"
					x2="846.43"
					y2="735.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="846.43"
					y1="735.7"
					x2="846.43"
					y2="693.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="846.43"
					y1="693.54"
					x2="844.93"
					y2="692.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m841.88,702.2c0-4.16-3.37-7.53-7.52-7.53s-7.53,3.37-7.53,7.53,3.37,7.52,7.53,7.52,7.52-3.37,7.52-7.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m840,727.04c0-3.12-2.53-5.64-5.64-5.64s-5.64,2.53-5.64,5.64,2.52,5.64,5.64,5.64,5.64-2.53,5.64-5.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m811.34,702.2c0-3.12-2.53-5.65-5.65-5.65s-5.64,2.53-5.64,5.65,2.53,5.64,5.64,5.64,5.65-2.53,5.65-5.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m813.22,727.04c0-4.15-3.37-7.52-7.53-7.52s-7.52,3.37-7.52,7.52,3.37,7.53,7.52,7.53,7.53-3.37,7.53-7.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="877.89 618.42 877.89 666.01 878.33 667.08 879.4 667.52 911.27 667.52 912.33 667.08 912.77 666.01 912.77 618.42 912.33 617.35 911.27 616.91 879.4 616.91 878.33 617.35 877.89 618.42"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m877.89,618.42c0-.83.68-1.51,1.51-1.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.27"
					y1="616.91"
					x2="879.4"
					y2="616.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m911.27,616.91c.83,0,1.5.68,1.5,1.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="912.77"
					y1="666.01"
					x2="912.77"
					y2="618.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m912.77,666.01c0,.83-.67,1.5-1.5,1.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="879.4"
					y1="667.52"
					x2="911.27"
					y2="667.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m879.4,667.52c-.83,0-1.51-.67-1.51-1.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.89"
					y1="618.42"
					x2="877.89"
					y2="666.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="881.65"
					y1="622.18"
					x2="881.65"
					y2="662.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="883.16"
					y1="663.76"
					x2="903.74"
					y2="663.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="905.25"
					y1="662.25"
					x2="905.25"
					y2="622.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="903.74"
					y1="620.67"
					x2="883.16"
					y2="620.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="881.65"
					y1="622.18"
					x2="881.65"
					y2="622.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m883.16,663.76c-.83,0-1.5-.68-1.5-1.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m905.25,662.25c0,.83-.68,1.51-1.5,1.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m903.74,620.67c.83,0,1.5.67,1.5,1.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m881.65,622.18c0-.83.67-1.5,1.5-1.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m899.98,642.21c0-1.25-1.01-2.26-2.26-2.26s-2.26,1.01-2.26,2.26,1.01,2.26,2.26,2.26,2.26-1.01,2.26-2.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="895.63 641.54 895.15 641.74 894.95 642.22 895.15 642.69 895.63 642.89 910.51 642.89 910.99 642.69 911.19 642.21 910.99 641.74 910.51 641.54 895.63 641.54"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="910.51"
					y1="641.54"
					x2="895.63"
					y2="641.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m910.51,641.54c.37,0,.68.3.68.68s-.3.68-.68.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.63"
					y1="642.89"
					x2="910.51"
					y2="642.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m895.63,642.89h0c-.37,0-.68-.3-.68-.68s.3-.68.68-.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="906.68 640.71 906.68 641.54 910.51 641.54 910.99 641.74 911.19 642.21 910.99 642.69 910.51 642.89 906.68 642.89 906.68 643.72 911.57 643.72 911.57 640.71 906.68 640.71"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="911.57"
					y1="640.71"
					x2="906.68"
					y2="640.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.57"
					y1="643.72"
					x2="911.57"
					y2="640.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.68"
					y1="643.72"
					x2="911.57"
					y2="643.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.68"
					y1="642.89"
					x2="906.68"
					y2="643.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.51"
					y1="642.89"
					x2="906.68"
					y2="642.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m910.51,641.54c.37,0,.68.3.68.68s-.3.68-.68.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.68"
					y1="641.54"
					x2="910.51"
					y2="641.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.68"
					y1="640.71"
					x2="906.68"
					y2="641.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="903.97 640.73 903.97 641.54 906.6 641.54 906.6 640.73 903.97 640.73"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="906.6"
					y1="640.73"
					x2="903.97"
					y2="640.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.6"
					y1="641.54"
					x2="906.6"
					y2="640.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="903.97"
					y1="641.54"
					x2="906.6"
					y2="641.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="903.97"
					y1="640.73"
					x2="903.97"
					y2="641.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="903.97 643.7 906.6 643.7 906.6 642.89 903.97 642.89 903.97 643.7"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="903.97"
					y1="642.89"
					x2="903.97"
					y2="643.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.6"
					y1="642.89"
					x2="903.97"
					y2="642.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.6"
					y1="643.7"
					x2="906.6"
					y2="642.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="903.97"
					y1="643.7"
					x2="906.6"
					y2="643.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="545.13"
					y1="719.23"
					x2="545.13"
					y2="705.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="545.13"
					y1="705.86"
					x2="508.82"
					y2="705.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="552.78"
					y1="719.23"
					x2="501.18"
					y2="719.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.18"
					y1="753.63"
					x2="552.78"
					y2="753.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="552.78"
					y1="753.63"
					x2="552.78"
					y2="702.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.18"
					y1="702.03"
					x2="501.18"
					y2="753.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="552.78"
					y1="702.99"
					x2="501.18"
					y2="702.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.82"
					y1="719.23"
					x2="508.82"
					y2="705.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="552.78"
					y1="702.03"
					x2="501.18"
					y2="702.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.12"
					y1="241.69"
					x2="584.08"
					y2="241.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.08"
					y1="226.41"
					x2="454.86"
					y2="226.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.56"
					y1="241.69"
					x2="881.71"
					y2="241.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="881.71"
					y1="226.41"
					x2="732.56"
					y2="226.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.2"
					y1="684.25"
					x2="772.2"
					y2="680.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.2"
					y1="680.48"
					x2="770.29"
					y2="680.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.29"
					y1="680.48"
					x2="770.29"
					y2="684.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.66"
					y1="693.6"
					x2="715.32"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="718.08"
					y1="693.6"
					x2="722.67"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.42"
					y1="693.6"
					x2="730"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.76"
					y1="693.6"
					x2="737.34"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.09"
					y1="693.6"
					x2="744.68"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.43"
					y1="693.6"
					x2="752.02"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.77"
					y1="693.6"
					x2="759.36"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="762.11"
					y1="693.6"
					x2="766.69"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.45"
					y1="693.6"
					x2="774.11"
					y2="693.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.4"
					y1="568.58"
					x2="918.27"
					y2="568.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="545.13"
					y1="747.9"
					x2="508.82"
					y2="747.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.82"
					y1="747.9"
					x2="508.82"
					y2="723.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.82"
					y1="723.06"
					x2="545.13"
					y2="723.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="545.13"
					y1="723.06"
					x2="545.13"
					y2="747.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="496.84"
					y1="757.35"
					x2="496.84"
					y2="703.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.28"
					y1="693.6"
					x2="487.28"
					y2="757.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="774.11"
					y1="716.53"
					x2="778.31"
					y2="716.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.06"
					y1="716.53"
					x2="785.65"
					y2="716.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="788.4"
					y1="716.53"
					x2="792.98"
					y2="716.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="795.74"
					y1="716.53"
					x2="800.32"
					y2="716.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.07"
					y1="716.53"
					x2="807.66"
					y2="716.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="810.41"
					y1="716.53"
					x2="815"
					y2="716.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="817.75"
					y1="716.53"
					x2="822.34"
					y2="716.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825.09"
					y1="716.53"
					x2="829.68"
					y2="716.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="832.43"
					y1="716.53"
					x2="837.02"
					y2="716.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="839.77"
					y1="716.53"
					x2="844.35"
					y2="716.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="847.11"
					y1="716.53"
					x2="851.69"
					y2="716.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="854.44"
					y1="716.53"
					x2="859.03"
					y2="716.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="861.78"
					y1="716.53"
					x2="866.37"
					y2="716.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="869.12"
					y1="716.53"
					x2="873.71"
					y2="716.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="876.46"
					y1="716.53"
					x2="881.05"
					y2="716.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="883.8"
					y1="716.53"
					x2="888.38"
					y2="716.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="891.14"
					y1="716.53"
					x2="895.33"
					y2="716.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.33"
					y1="716.53"
					x2="895.33"
					y2="713.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.33"
					y1="710.9"
					x2="895.33"
					y2="706.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.33"
					y1="703.56"
					x2="895.33"
					y2="698.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.33"
					y1="696.22"
					x2="895.33"
					y2="691.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.33"
					y1="688.88"
					x2="895.33"
					y2="684.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.33"
					y1="681.54"
					x2="895.33"
					y2="676.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.33"
					y1="674.2"
					x2="895.33"
					y2="669.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.33"
					y1="666.86"
					x2="895.33"
					y2="662.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.33"
					y1="659.53"
					x2="895.33"
					y2="654.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.33"
					y1="652.19"
					x2="895.33"
					y2="647.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.33"
					y1="644.85"
					x2="895.33"
					y2="640.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.33"
					y1="637.51"
					x2="895.33"
					y2="632.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.33"
					y1="630.17"
					x2="895.33"
					y2="625.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.33"
					y1="622.83"
					x2="895.33"
					y2="618.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.33"
					y1="615.49"
					x2="895.33"
					y2="610.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.33"
					y1="608.16"
					x2="895.33"
					y2="603.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.33"
					y1="600.82"
					x2="895.33"
					y2="596.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.33"
					y1="593.48"
					x2="895.33"
					y2="588.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.33"
					y1="586.14"
					x2="895.33"
					y2="581.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.33"
					y1="578.8"
					x2="895.33"
					y2="574.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.33"
					y1="571.46"
					x2="895.33"
					y2="568.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="732.56 226.4 732.56 241.69 642.22 241.69 642.22 578.78 622.63 578.78 622.63 569.23 632.67 569.23 632.67 304.38 589.77 304.38 589.77 241.69 584.08 241.69 584.08 226.4 732.56 226.4"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.1"
				/>
				<polygon
					points="241.58 590.7 241.58 578.78 65.29 578.78 65.29 692.99 123.61 692.99 123.61 717.55 241.58 717.55 241.58 651.85 251.14 651.85 251.14 757.35 373.19 757.35 373.19 772.64 235.85 772.64 235.85 732.84 50 732.84 50 563.49 351.44 563.49 351.44 226.4 456.12 226.4 456.12 241.69 366.73 241.69 366.73 515.66 390.5 515.66 390.5 525.22 366.73 525.22 366.73 569.23 504.68 569.23 504.68 525.22 480.41 525.22 480.41 515.66 514.23 515.66 514.23 569.23 561.47 569.23 561.47 578.78 251.14 578.78 251.14 590.7 241.58 590.7"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.1"
				/>
				<polygon
					points="950 226.4 950 772.64 445.81 772.64 445.81 757.35 487.28 757.35 487.28 693.6 498.31 693.6 498.31 703.16 496.84 703.16 496.84 757.35 557.12 757.35 557.12 703.16 555.64 703.16 555.64 693.6 613.37 693.6 613.37 703.16 587.36 703.16 587.36 757.35 701.11 757.35 701.11 703.16 674.51 703.16 674.51 693.6 710.66 693.6 710.66 755.11 774.11 755.11 774.11 739.47 918.27 739.47 918.27 502.97 934.71 502.97 934.71 274.23 929.96 274.23 929.96 241.69 881.72 241.69 881.72 226.4 950 226.4"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.1"
				/>
			</g>
			<g id="text">
				<path d="m739.59,724.99h-1.24l-1.49-2.5c-.14-.23-.27-.43-.4-.59-.13-.17-.26-.3-.4-.4-.13-.1-.28-.18-.44-.22-.15-.05-.33-.07-.52-.07h-.86v3.8h-1.05v-8.92h2.66c.39,0,.75.05,1.08.15.33.1.62.24.86.44.24.2.44.45.57.75.14.29.21.64.21,1.04,0,.31-.05.6-.14.86-.09.26-.22.49-.4.69-.17.2-.38.38-.62.52-.24.14-.51.25-.82.33v.02c.15.07.28.14.39.23.11.08.22.18.32.3.1.12.2.25.29.4.1.15.21.32.33.51l1.67,2.68Zm-5.35-7.98v3.24h1.42c.26,0,.5-.04.72-.12.22-.08.42-.19.58-.34.16-.15.29-.33.38-.54.09-.22.14-.46.14-.72,0-.48-.16-.85-.47-1.11-.31-.27-.75-.4-1.34-.4h-1.43Zm11.44,5.05h-4.5c.02.71.21,1.26.57,1.64.36.39.87.58,1.51.58.72,0,1.38-.24,1.98-.71v.96c-.56.41-1.3.61-2.22.61s-1.61-.29-2.12-.86c-.51-.58-.77-1.4-.77-2.45,0-.99.28-1.8.84-2.42.56-.63,1.26-.94,2.1-.94s1.48.27,1.94.81c.46.54.68,1.29.68,2.25v.54Zm-1.05-.86c0-.59-.15-1.05-.43-1.38-.28-.33-.67-.49-1.16-.49s-.89.17-1.23.52c-.34.34-.54.79-.62,1.35h3.44Zm5.62-4.74c-.2-.11-.43-.17-.68-.17-.71,0-1.07.45-1.07,1.35v.98h1.49v.87h-1.49v5.5h-1.01v-5.5h-1.09v-.87h1.09v-1.03c0-.67.19-1.19.58-1.58.39-.39.87-.58,1.44-.58.31,0,.56.04.74.11v.92Z" />
				<path d="m751.34,725.13c-.19,0-.35-.07-.49-.21-.13-.14-.2-.3-.2-.49s.07-.35.2-.49c.14-.14.3-.21.49-.21s.36.07.5.21c.14.14.21.3.21.49s-.07.35-.21.49c-.14.14-.3.21-.5.21Z" />
				<path d="m896.27,596.66v-8.86h3.05c.69,0,1.22.04,1.58.13.51.12.94.33,1.3.63.47.4.82.9,1.05,1.52.23.61.35,1.31.35,2.1,0,.67-.08,1.27-.24,1.79-.16.52-.36.95-.6,1.29-.25.34-.52.61-.81.8-.29.19-.64.34-1.06.44-.41.1-.88.15-1.42.15h-3.2Zm1.17-1.05h1.89c.58,0,1.04-.05,1.37-.16.33-.11.6-.26.8-.46.28-.28.49-.65.65-1.12.16-.47.24-1.04.24-1.71,0-.93-.15-1.64-.46-2.13-.3-.5-.67-.83-1.11-1-.31-.12-.82-.18-1.52-.18h-1.86v6.77Zm9.32,1.05l-2.35-8.86h1.2l1.35,5.81c.15.61.27,1.21.37,1.81.23-.95.36-1.49.4-1.64l1.69-5.99h1.41l1.27,4.49c.32,1.11.55,2.16.69,3.14.11-.56.26-1.2.44-1.93l1.39-5.7h1.18l-2.43,8.86h-1.13l-1.87-6.75c-.16-.56-.25-.91-.28-1.04-.09.41-.18.75-.26,1.04l-1.88,6.75h-1.2Z" />
				<path d="m710.88,408.89h-7.19v-13.86h1.62v12.39h5.57v1.47Zm2.72-12.41c-.28,0-.53-.1-.72-.29-.2-.19-.3-.44-.3-.73s.1-.54.3-.73c.2-.2.44-.3.72-.3s.53.1.73.3c.21.19.31.44.31.73s-.1.53-.31.72c-.2.2-.44.3-.73.3Zm.77,12.41h-1.58v-9.9h1.58v9.9Zm10.98-9.9l-3.94,9.9h-1.56l-3.75-9.9h1.74l2.51,7.19c.19.53.3.99.35,1.38h.04c.06-.5.17-.94.31-1.34l2.63-7.23h1.67Zm2.5-2.51c-.28,0-.53-.1-.72-.29-.2-.19-.3-.44-.3-.73s.1-.54.3-.73c.2-.2.44-.3.72-.3s.53.1.73.3c.21.19.31.44.31.73s-.1.53-.31.72c-.2.2-.44.3-.73.3Zm.77,12.41h-1.59v-9.9h1.59v9.9Zm11.41,0h-1.58v-5.64c0-2.1-.77-3.15-2.3-3.15-.79,0-1.45.3-1.97.9-.52.59-.77,1.34-.77,2.25v5.64h-1.58v-9.9h1.58v1.64h.04c.75-1.25,1.83-1.87,3.25-1.87,1.08,0,1.91.35,2.48,1.05.57.7.86,1.7.86,3.02v6.05Zm11.42-.79c0,3.63-1.74,5.45-5.22,5.45-1.22,0-2.29-.23-3.21-.7v-1.58c1.11.62,2.18.93,3.19.93,2.44,0,3.65-1.29,3.65-3.88v-1.08h-.04c-.75,1.26-1.89,1.89-3.4,1.89-1.23,0-2.22-.44-2.98-1.31-.75-.88-1.12-2.06-1.12-3.55,0-1.68.4-3.02,1.21-4.01.81-.99,1.92-1.49,3.32-1.49s2.32.53,2.97,1.6h.04v-1.37h1.58v9.1Zm-1.58-3.68v-1.46c0-.79-.27-1.46-.8-2.02-.53-.56-1.19-.84-1.98-.84-.98,0-1.75.36-2.3,1.07-.55.71-.83,1.7-.83,2.99,0,1.1.26,1.98.79,2.65.53.66,1.24.99,2.12.99s1.61-.32,2.16-.95c.56-.63.84-1.44.84-2.43h0Z" />
				<polygon points="760.91 395.03 754.26 411.19 752.78 411.19 759.41 395.03 760.91 395.03" />
				<path d="m762.52,408.89v-13.86h3.83c4.88,0,7.33,2.25,7.33,6.76,0,2.14-.68,3.86-2.04,5.16-1.35,1.3-3.17,1.94-5.44,1.94h-3.67Zm1.62-12.39v10.92h2.07c1.82,0,3.23-.49,4.24-1.46,1.01-.97,1.52-2.35,1.52-4.14,0-3.55-1.89-5.32-5.66-5.32h-2.16Zm12.79-.02c-.28,0-.53-.1-.72-.29-.2-.19-.3-.44-.3-.73s.1-.54.3-.73c.2-.2.44-.3.72-.3s.53.1.73.3c.21.19.31.44.31.73s-.1.53-.31.72c-.2.2-.44.3-.73.3Zm.77,12.41h-1.59v-9.9h1.59v9.9Zm11.36,0h-1.58v-5.64c0-2.1-.77-3.15-2.3-3.15-.79,0-1.45.3-1.97.9-.52.59-.77,1.34-.77,2.25v5.64h-1.58v-9.9h1.58v1.64h.04c.75-1.25,1.83-1.87,3.25-1.87,1.08,0,1.91.35,2.48,1.05.57.7.86,1.7.86,3.02v6.05Zm3.74-12.41c-.28,0-.53-.1-.72-.29-.2-.19-.3-.44-.3-.73s.1-.54.3-.73c.2-.2.44-.3.72-.3s.53.1.73.3c.21.19.31.44.31.73s-.1.53-.31.72c-.2.2-.44.3-.73.3Zm.77,12.41h-1.59v-9.9h1.59v9.9Zm11.36,0h-1.58v-5.64c0-2.1-.77-3.15-2.3-3.15-.79,0-1.45.3-1.97.9-.52.59-.77,1.34-.77,2.25v5.64h-1.59v-9.9h1.59v1.64h.04c.75-1.25,1.83-1.87,3.25-1.87,1.08,0,1.91.35,2.48,1.05.57.7.86,1.7.86,3.02v6.05Zm11.37-.79c0,3.63-1.74,5.45-5.22,5.45-1.22,0-2.29-.23-3.21-.7v-1.58c1.11.62,2.18.93,3.19.93,2.44,0,3.65-1.29,3.65-3.88v-1.08h-.04c-.75,1.26-1.89,1.89-3.4,1.89-1.23,0-2.22-.44-2.98-1.31-.75-.88-1.12-2.06-1.12-3.55,0-1.68.4-3.02,1.21-4.01.81-.99,1.92-1.49,3.32-1.49s2.32.53,2.97,1.6h.04v-1.37h1.58v9.1Zm-1.58-3.68v-1.46c0-.79-.27-1.46-.8-2.02-.53-.56-1.19-.84-1.98-.84-.98,0-1.75.36-2.3,1.07-.55.71-.83,1.7-.83,2.99,0,1.1.26,1.98.79,2.65.53.66,1.24.99,2.12.99s1.61-.32,2.16-.95c.56-.63.84-1.44.84-2.43Z" />
				<path d="m835.24,408.89h-1.93l-2.32-3.89c-.21-.36-.42-.67-.62-.92-.2-.26-.41-.47-.62-.63-.21-.16-.43-.28-.68-.35-.24-.08-.51-.12-.81-.12h-1.33v5.9h-1.62v-13.86h4.14c.61,0,1.16.08,1.67.23.52.15.96.38,1.33.69.38.31.68.7.89,1.16.21.46.32,1,.32,1.61,0,.48-.07.93-.22,1.33-.14.4-.35.76-.62,1.07-.26.32-.59.59-.97.81-.37.22-.8.39-1.27.51v.04c.23.1.43.22.6.36.17.13.34.28.49.46.15.18.31.39.45.62.15.23.33.49.51.79l2.6,4.17Zm-8.31-12.39v5.03h2.2c.41,0,.78-.06,1.12-.18.35-.12.65-.3.9-.52.25-.23.45-.51.59-.84.14-.34.21-.71.21-1.12,0-.74-.24-1.32-.72-1.73-.48-.42-1.17-.63-2.08-.63h-2.22Zm14.07,12.62c-1.46,0-2.63-.46-3.51-1.38-.87-.93-1.3-2.16-1.3-3.68,0-1.66.45-2.96,1.36-3.89.91-.93,2.14-1.4,3.68-1.4s2.63.45,3.45,1.36c.83.91,1.25,2.17,1.25,3.78s-.45,2.84-1.34,3.8c-.89.95-2.08,1.42-3.59,1.42Zm.12-9.03c-1.02,0-1.82.35-2.42,1.04-.59.69-.89,1.64-.89,2.86s.3,2.1.9,2.77c.6.68,1.4,1.01,2.41,1.01s1.81-.33,2.36-1c.55-.66.83-1.61.83-2.83s-.28-2.19-.83-2.86c-.55-.67-1.33-1.01-2.36-1.01Zm11.42,9.03c-1.46,0-2.63-.46-3.51-1.38-.87-.93-1.3-2.16-1.3-3.68,0-1.66.45-2.96,1.36-3.89.91-.93,2.14-1.4,3.68-1.4s2.63.45,3.45,1.36c.83.91,1.25,2.17,1.25,3.78s-.45,2.84-1.34,3.8c-.89.95-2.08,1.42-3.59,1.42Zm.12-9.03c-1.02,0-1.82.35-2.42,1.04-.59.69-.89,1.64-.89,2.86s.3,2.1.9,2.77c.6.68,1.4,1.01,2.41,1.01s1.81-.33,2.36-1c.55-.66.83-1.61.83-2.83s-.28-2.19-.83-2.86c-.55-.67-1.33-1.01-2.36-1.01Zm21.33,8.79h-1.58v-5.68c0-1.1-.17-1.89-.51-2.38-.33-.49-.9-.73-1.7-.73-.68,0-1.25.31-1.73.93-.47.62-.71,1.36-.71,2.22v5.64h-1.58v-5.88c0-1.95-.75-2.92-2.25-2.92-.7,0-1.27.29-1.72.88-.45.58-.68,1.34-.68,2.27v5.64h-1.58v-9.9h1.58v1.57h.04c.7-1.2,1.73-1.8,3.07-1.8.68,0,1.27.19,1.77.57.5.37.85.87,1.03,1.48.73-1.37,1.83-2.05,3.29-2.05,2.18,0,3.27,1.34,3.27,4.03v6.1Z" />
				<path d="m754.08,429.42h-1.15v-8.71c-.09.09-.22.19-.39.31-.17.11-.36.22-.58.34-.21.11-.44.22-.67.32-.23.1-.46.18-.69.23v-1.17c.25-.07.52-.16.8-.28.29-.12.56-.26.84-.4.28-.15.54-.3.78-.46.24-.16.45-.32.63-.48h.44v10.3Zm8.11-7.43c0-.31-.05-.58-.15-.81-.09-.23-.22-.42-.39-.57-.16-.15-.36-.27-.58-.34-.22-.07-.47-.11-.73-.11-.22,0-.45.03-.66.09-.22.06-.43.15-.63.25-.2.11-.4.24-.59.39-.19.15-.36.32-.53.5v-1.24c.32-.31.68-.55,1.08-.72.4-.17.89-.25,1.47-.25.41,0,.79.06,1.15.18.35.12.66.29.91.52.26.23.46.51.6.85.15.34.22.72.22,1.16,0,.4-.05.76-.14,1.08-.09.32-.23.63-.41.91-.18.29-.41.56-.7.82-.28.26-.61.53-.99.8-.47.34-.86.63-1.17.86-.3.24-.55.46-.73.67-.18.21-.3.41-.38.63-.07.21-.11.44-.11.72h5.02v1.03h-6.22v-.5c0-.43.05-.81.14-1.14.09-.33.25-.64.46-.93.22-.3.5-.59.84-.89.35-.3.78-.63,1.29-1,.37-.26.67-.51.91-.75.25-.24.45-.48.6-.72.15-.24.26-.48.32-.72.07-.25.1-.51.1-.79Z" />
				<rect x="765.68" y="419.35" width="1.02" height="3.14" />
				<path d="m774.85,423.78c0,.92-.09,1.74-.27,2.47-.18.72-.45,1.33-.8,1.83-.35.5-.78.88-1.29,1.14-.51.26-1.08.39-1.73.39s-1.25-.12-1.76-.35v-1.1c.56.31,1.15.47,1.78.47.45,0,.86-.09,1.22-.28.36-.19.67-.46.91-.82.25-.36.44-.8.57-1.33.13-.52.2-1.13.2-1.81h-.03c-.43.87-1.18,1.3-2.25,1.3-.43,0-.83-.07-1.19-.22-.36-.15-.67-.37-.93-.65-.26-.28-.47-.61-.61-1-.15-.38-.22-.81-.22-1.27,0-.5.08-.95.24-1.36.16-.41.39-.77.67-1.06.29-.3.63-.53,1.03-.7.4-.16.83-.25,1.3-.25.51,0,.95.1,1.34.31.39.2.72.5.99.89.27.39.47.87.61,1.44.14.57.21,1.22.21,1.96Zm-1.24-1.03c0-.39-.05-.74-.15-1.06-.1-.32-.24-.59-.41-.82-.18-.23-.39-.41-.64-.53-.24-.13-.51-.19-.8-.19s-.53.06-.77.17c-.24.11-.45.26-.63.46-.17.2-.31.43-.41.71-.1.27-.15.57-.15.89,0,.36.05.67.14.96.1.28.24.52.41.72.18.19.39.34.64.44.25.1.53.15.84.15.27,0,.52-.05.75-.15.24-.1.44-.24.62-.41.18-.17.32-.37.41-.6.1-.23.15-.48.15-.75Z" />
				<path d="m777.73,419.35v3.14h-1.02v-3.14h1.02Zm2.33,0v3.14h-1.02v-3.14h1.02Z" />
				<path d="m791.58,422.23l-2.42,3.64,2.37,3.56h-1.34l-1.41-2.33c-.09-.15-.19-.33-.32-.55h-.03s-.13.22-.33.55l-1.44,2.33h-1.33l2.45-3.53-2.35-3.67h1.34l1.39,2.46c.1.18.2.37.3.56h.03l1.8-3.02h1.27Z" />
				<path d="m800.8,429.42h-1.15v-8.71c-.09.09-.22.19-.39.31-.17.11-.36.22-.58.34-.21.11-.44.22-.67.32-.23.1-.46.18-.69.23v-1.17c.25-.07.52-.16.8-.28.29-.12.56-.26.84-.4.28-.15.54-.3.78-.46.24-.16.45-.32.63-.48h.44v10.3Zm8.66-10.08v6.65h1.29v1.05h-1.29v2.37h-1.14v-2.37h-4.74v-1c.44-.5.89-1.03,1.33-1.59.45-.57.88-1.14,1.29-1.72.41-.58.79-1.16,1.14-1.74.35-.58.65-1.14.89-1.67h1.23Zm-4.57,6.65h3.44v-4.93c-.35.61-.68,1.16-1,1.64-.31.48-.61.92-.9,1.31-.28.39-.55.75-.81,1.07-.26.32-.5.62-.73.91Z" />
				<rect x="812.4" y="419.35" width="1.02" height="3.14" />
				<path d="m821.61,420.02c-.15.27-.34.6-.56,1-.22.4-.45.85-.69,1.34-.24.5-.49,1.03-.74,1.6-.25.57-.49,1.16-.71,1.77-.22.61-.41,1.23-.58,1.85-.16.62-.28,1.24-.36,1.84h-1.24c.08-.6.21-1.21.39-1.83.18-.63.38-1.24.6-1.84.22-.6.46-1.19.71-1.74.25-.56.49-1.07.72-1.54.23-.47.45-.88.64-1.24.2-.36.35-.64.47-.84h-5.05v-1.04h6.41v.67Z" />
				<path d="m824.45,419.35v3.14h-1.02v-3.14h1.02Zm2.33,0v3.14h-1.02v-3.14h1.02Z" />
				<path d="m461.35,377.33v-13.86h3.94c1.2,0,2.15.29,2.85.88.7.59,1.05,1.35,1.05,2.29,0,.79-.21,1.47-.64,2.05-.43.58-1.01.99-1.76,1.24v.04c.93.11,1.68.46,2.24,1.06.56.59.84,1.37.84,2.32,0,1.19-.43,2.15-1.28,2.88-.85.73-1.92,1.1-3.22,1.1h-4.04Zm1.62-12.39v4.47h1.66c.89,0,1.59-.21,2.1-.64.51-.43.76-1.04.76-1.82,0-1.35-.89-2.02-2.66-2.02h-1.87Zm0,5.93v4.99h2.2c.95,0,1.69-.23,2.21-.68.53-.45.79-1.07.79-1.86,0-1.64-1.11-2.45-3.34-2.45h-1.87Zm17.44,1.9h-6.99c.03,1.1.32,1.95.89,2.55.57.6,1.35.9,2.34.9,1.11,0,2.14-.37,3.07-1.1v1.49c-.87.63-2.02.95-3.45.95s-2.5-.45-3.3-1.34c-.8-.9-1.2-2.17-1.2-3.8,0-1.54.43-2.79,1.3-3.76.88-.97,1.96-1.46,3.26-1.46s2.3.42,3.01,1.26c.71.84,1.06,2,1.06,3.49v.83Zm-1.62-1.34c0-.91-.23-1.63-.67-2.14-.43-.51-1.03-.76-1.81-.76s-1.38.27-1.9.8c-.52.53-.84,1.23-.97,2.1h5.34Zm12.45,5.9h-1.58v-1.68h-.04c-.73,1.28-1.87,1.91-3.4,1.91-1.24,0-2.24-.44-2.99-1.32-.74-.89-1.11-2.1-1.11-3.62,0-1.64.41-2.95,1.24-3.93.82-.99,1.92-1.48,3.3-1.48s2.35.53,2.97,1.6h.04v-6.13h1.58v14.65Zm-1.58-4.47v-1.46c0-.8-.26-1.48-.79-2.03-.53-.55-1.2-.83-2.01-.83-.97,0-1.73.35-2.28,1.06-.55.71-.83,1.69-.83,2.94,0,1.14.26,2.04.79,2.71.53.66,1.25.99,2.15.99s1.6-.32,2.15-.96c.55-.64.83-1.44.83-2.42Zm9.94-3.82c-.28-.21-.68-.32-1.2-.32-.68,0-1.24.32-1.7.96-.45.64-.68,1.51-.68,2.61v5.04h-1.58v-9.9h1.58v2.04h.04c.23-.7.57-1.24,1.03-1.62.46-.39.98-.59,1.56-.59.41,0,.73.05.95.14v1.64Zm5.84,8.52c-1.46,0-2.63-.46-3.51-1.38-.87-.93-1.3-2.16-1.3-3.68,0-1.66.45-2.96,1.36-3.89.91-.93,2.14-1.4,3.68-1.4s2.63.45,3.45,1.36c.83.91,1.25,2.17,1.25,3.78s-.45,2.84-1.34,3.8c-.89.95-2.08,1.42-3.59,1.42Zm.12-9.03c-1.02,0-1.82.35-2.42,1.04-.59.69-.89,1.64-.89,2.86s.3,2.1.9,2.77c.6.68,1.4,1.01,2.41,1.01s1.81-.33,2.36-1c.55-.66.83-1.61.83-2.83s-.28-2.19-.83-2.86c-.55-.67-1.33-1.01-2.36-1.01Zm11.46,9.03c-1.46,0-2.63-.46-3.51-1.38-.87-.93-1.3-2.16-1.3-3.68,0-1.66.45-2.96,1.36-3.89.91-.93,2.14-1.4,3.68-1.4s2.63.45,3.45,1.36c.83.91,1.25,2.17,1.25,3.78s-.45,2.84-1.34,3.8c-.89.95-2.08,1.42-3.59,1.42Zm.12-9.03c-1.02,0-1.82.35-2.42,1.04-.59.69-.89,1.64-.89,2.86s.3,2.1.9,2.77c.6.68,1.4,1.01,2.41,1.01s1.81-.33,2.36-1c.55-.66.83-1.61.83-2.83s-.28-2.19-.83-2.86c-.55-.67-1.33-1.01-2.36-1.01Zm21.38,8.79h-1.58v-5.68c0-1.1-.17-1.89-.51-2.38-.34-.49-.9-.73-1.7-.73-.68,0-1.25.31-1.73.93-.47.62-.71,1.36-.71,2.22v5.64h-1.58v-5.88c0-1.95-.75-2.92-2.25-2.92-.7,0-1.27.29-1.72.88-.45.58-.68,1.34-.68,2.27v5.64h-1.58v-9.9h1.58v1.57h.04c.7-1.2,1.73-1.8,3.07-1.8.68,0,1.27.19,1.77.57.5.37.85.87,1.03,1.48.73-1.37,1.83-2.05,3.29-2.05,2.18,0,3.27,1.34,3.27,4.03v6.1Z" />
				<path d="m465.31,397.86h-1.15v-8.71c-.09.09-.22.19-.39.31-.17.11-.36.22-.58.34-.21.11-.44.22-.67.32-.23.1-.46.18-.69.23v-1.17c.25-.07.52-.16.8-.28.29-.12.56-.26.84-.4.28-.15.54-.3.78-.46.24-.16.45-.32.63-.48h.44v10.3Zm7.77,0h-1.15v-8.71c-.09.09-.22.19-.39.31-.17.11-.36.22-.58.34-.21.11-.44.22-.67.32-.23.1-.46.18-.69.23v-1.17c.25-.07.52-.16.8-.28.29-.12.56-.26.84-.4.28-.15.54-.3.78-.46.24-.16.45-.32.63-.48h.44v10.3Z" />
				<rect x="476.91" y="387.79" width="1.02" height="3.14" />
				<path d="m486.12,388.46c-.15.27-.34.6-.56,1-.22.4-.44.85-.69,1.34-.24.5-.49,1.03-.74,1.6-.25.57-.49,1.16-.71,1.77-.22.61-.41,1.23-.58,1.85-.16.62-.28,1.24-.36,1.84h-1.24c.08-.6.21-1.21.39-1.83.18-.63.38-1.24.6-1.84.22-.6.46-1.19.71-1.74.25-.56.49-1.07.72-1.54.23-.47.45-.88.64-1.24.2-.36.35-.64.47-.84h-5.05v-1.04h6.41v.67Z" />
				<path d="m488.96,387.79v3.14h-1.02v-3.14h1.02Zm2.33,0v3.14h-1.02v-3.14h1.02Z" />
				<path d="m502.81,390.67l-2.42,3.64,2.37,3.56h-1.34l-1.41-2.33c-.09-.15-.19-.33-.32-.55h-.03s-.13.22-.33.55l-1.44,2.33h-1.33l2.45-3.53-2.35-3.67h1.34l1.39,2.46c.1.18.2.37.3.56h.03l1.8-3.02h1.27Z" />
				<path d="m512.03,397.86h-1.15v-8.71c-.09.09-.22.19-.39.31-.17.11-.36.22-.58.34-.21.11-.44.22-.67.32-.23.1-.46.18-.69.23v-1.17c.25-.07.52-.16.8-.28.29-.12.56-.26.84-.4.28-.15.54-.3.78-.46.24-.16.45-.32.63-.48h.44v10.3Zm9.38-2.85c0,.45-.09.87-.26,1.24-.17.37-.41.69-.72.96-.31.26-.68.47-1.12.61s-.92.22-1.44.22c-.96,0-1.72-.18-2.29-.55v-1.24c.68.53,1.46.8,2.33.8.35,0,.67-.04.95-.13.29-.09.53-.22.73-.39.21-.17.36-.37.47-.61.11-.24.17-.51.17-.81,0-1.32-.94-1.97-2.81-1.97h-.84v-.98h.79c1.66,0,2.49-.62,2.49-1.85,0-1.14-.63-1.71-1.9-1.71-.71,0-1.38.24-2,.72v-1.12c.64-.38,1.41-.58,2.29-.58.42,0,.8.06,1.15.18.34.12.63.28.88.49.24.21.43.46.56.76.14.3.2.62.2.98,0,1.33-.67,2.18-2.01,2.56v.03c.34.04.66.12.95.25.29.13.54.29.75.5.21.21.37.45.49.73.12.28.18.58.18.92h0Z" />
				<rect x="523.62" y="387.79" width="1.02" height="3.14" />
				<path d="m532.91,392.79c0,.84-.08,1.59-.23,2.24-.15.65-.37,1.2-.66,1.65-.29.44-.64.78-1.06,1.02-.42.23-.89.34-1.43.34-.51,0-.96-.11-1.36-.33-.39-.22-.73-.55-1-.98-.27-.43-.48-.95-.62-1.57-.14-.62-.21-1.33-.21-2.14,0-.88.07-1.66.22-2.33.15-.67.37-1.24.65-1.69.29-.46.64-.8,1.06-1.03.43-.23.91-.35,1.46-.35,2.11,0,3.17,1.72,3.17,5.16Zm-1.18.11c0-2.87-.68-4.3-2.04-4.3-1.44,0-2.16,1.46-2.16,4.38,0,2.72.7,4.08,2.11,4.08s2.09-1.39,2.09-4.16Z" />
				<path d="m535.67,387.79v3.14h-1.02v-3.14h1.02Zm2.33,0v3.14h-1.02v-3.14h1.02Z" />
				<path d="m770.61,639.58h-2.26l-5.35-6.34c-.2-.24-.32-.4-.37-.48h-.04v6.82h-1.62v-13.86h1.62v6.51h.04c.09-.14.21-.3.37-.47l5.18-6.04h2.02l-5.94,6.65,6.36,7.21Zm2.42-12.41c-.28,0-.53-.1-.72-.29-.2-.19-.3-.44-.3-.73s.1-.54.3-.73c.2-.2.44-.3.72-.3s.53.1.73.3c.21.19.31.44.31.73s-.1.53-.31.72c-.2.2-.44.3-.73.3Zm.77,12.41h-1.58v-9.9h1.58v9.9Zm7.78-.1c-.37.21-.87.31-1.48.31-1.73,0-2.6-.97-2.6-2.9v-5.86h-1.7v-1.35h1.7v-2.42l1.58-.51v2.93h2.49v1.35h-2.49v5.58c0,.66.11,1.14.34,1.42s.6.43,1.12.43c.4,0,.74-.11,1.03-.33v1.35Zm8.85-.36c-.76.46-1.66.69-2.71.69-1.41,0-2.55-.46-3.42-1.37-.86-.92-1.3-2.11-1.3-3.58,0-1.63.47-2.94,1.4-3.92.93-.99,2.18-1.49,3.74-1.49.87,0,1.64.16,2.3.48v1.62c-.73-.52-1.52-.77-2.36-.77-1.01,0-1.84.36-2.49,1.09-.64.72-.97,1.67-.97,2.85s.3,2.07.91,2.74c.61.67,1.43,1.01,2.45,1.01.86,0,1.68-.29,2.44-.86v1.51Zm10.6.45h-1.58v-5.7c0-2.06-.77-3.09-2.3-3.09-.77,0-1.42.3-1.95.9-.53.59-.79,1.36-.79,2.29v5.61h-1.58v-14.65h1.58v6.4h.04c.76-1.25,1.84-1.87,3.25-1.87,2.23,0,3.34,1.34,3.34,4.03v6.1Zm10.92-4.55h-6.99c.03,1.1.32,1.95.89,2.55.57.6,1.35.9,2.34.9,1.11,0,2.14-.37,3.07-1.1v1.49c-.87.63-2.02.95-3.45.95s-2.5-.45-3.3-1.34c-.8-.9-1.2-2.17-1.2-3.8,0-1.54.43-2.79,1.3-3.76.88-.97,1.96-1.46,3.26-1.46s2.3.42,3.01,1.26c.71.84,1.06,2,1.06,3.49v.83Zm-1.62-1.34c0-.91-.23-1.63-.67-2.14-.43-.51-1.03-.76-1.81-.76s-1.38.27-1.9.8c-.52.53-.84,1.23-.97,2.1h5.34Zm12.22,5.9h-1.58v-5.64c0-2.1-.77-3.15-2.3-3.15-.79,0-1.45.3-1.97.9-.52.59-.77,1.34-.77,2.25v5.64h-1.58v-9.9h1.58v1.64h.04c.75-1.25,1.83-1.87,3.25-1.87,1.08,0,1.91.35,2.48,1.05.57.7.86,1.7.86,3.02v6.05Z" />
				<path d="m396.44,676.11h-7.34v-13.86h7.04v1.47h-5.41v4.61h5.01v1.46h-5.01v4.85h5.72v1.47Zm10.68,0h-1.58v-5.64c0-2.1-.77-3.15-2.3-3.15-.79,0-1.45.3-1.97.9-.52.59-.77,1.34-.77,2.25v5.64h-1.58v-9.9h1.58v1.64h.04c.75-1.25,1.83-1.87,3.25-1.87,1.08,0,1.91.35,2.48,1.05.57.7.86,1.7.86,3.02v6.05Zm7.59-.1c-.37.21-.87.31-1.48.31-1.73,0-2.6-.97-2.6-2.9v-5.86h-1.7v-1.35h1.7v-2.42l1.58-.51v2.93h2.49v1.35h-2.49v5.58c0,.66.11,1.14.34,1.42.23.28.6.43,1.12.43.4,0,.74-.11,1.03-.33v1.35Zm7.29-8.2c-.28-.21-.68-.32-1.2-.32-.68,0-1.24.32-1.7.96-.45.64-.68,1.51-.68,2.61v5.04h-1.58v-9.9h1.58v2.04h.04c.23-.7.57-1.24,1.03-1.62.46-.39.98-.59,1.56-.59.41,0,.73.05.95.14v1.64Zm9.62-1.6l-4.55,11.48c-.81,2.05-1.95,3.07-3.42,3.07-.41,0-.76-.04-1.03-.13v-1.42c.34.12.65.17.94.17.8,0,1.4-.48,1.8-1.43l.79-1.87-3.87-9.88h1.76l2.68,7.62c.03.1.1.35.2.75h.06c.03-.15.1-.4.19-.73l2.81-7.63h1.64Z" />
				<path d="m146.8,637.31v-13.86h3.94c1.2,0,2.15.29,2.85.88.7.59,1.05,1.35,1.05,2.29,0,.79-.21,1.47-.64,2.05-.43.58-1.01.99-1.76,1.24v.04c.93.11,1.68.46,2.24,1.06.56.59.84,1.37.84,2.32,0,1.19-.43,2.15-1.28,2.88-.85.73-1.92,1.1-3.22,1.1h-4.04Zm1.62-12.39v4.47h1.66c.89,0,1.59-.21,2.1-.64.51-.43.76-1.04.76-1.82,0-1.35-.89-2.02-2.66-2.02h-1.87Zm0,5.93v4.99h2.2c.95,0,1.69-.23,2.21-.68.53-.45.79-1.07.79-1.86,0-1.64-1.11-2.45-3.34-2.45h-1.87Zm16.58,6.46h-1.58v-1.55h-.04c-.69,1.19-1.7,1.78-3.04,1.78-.99,0-1.76-.26-2.32-.78-.55-.52-.83-1.21-.83-2.08,0-1.85,1.09-2.93,3.27-3.23l2.97-.42c0-1.68-.68-2.52-2.04-2.52-1.19,0-2.27.41-3.23,1.22v-1.62c.97-.62,2.09-.93,3.36-.93,2.33,0,3.49,1.23,3.49,3.69v6.44Zm-1.58-5.01l-2.39.33c-.73.1-1.29.29-1.66.55-.37.26-.56.72-.56,1.38,0,.48.17.88.51,1.19.35.3.81.45,1.38.45.79,0,1.43-.27,1.94-.82.52-.55.77-1.25.77-2.1v-.99Zm9.16,4.91c-.37.21-.87.31-1.48.31-1.73,0-2.6-.97-2.6-2.9v-5.86h-1.7v-1.35h1.7v-2.42l1.58-.51v2.93h2.49v1.35h-2.49v5.58c0,.66.11,1.14.34,1.42.23.28.6.43,1.12.43.4,0,.74-.11,1.03-.33v1.35Zm10.33.1h-1.58v-5.7c0-2.06-.77-3.09-2.3-3.09-.77,0-1.42.3-1.95.9-.53.59-.79,1.36-.79,2.29v5.61h-1.58v-14.65h1.58v6.4h.04c.76-1.25,1.84-1.87,3.25-1.87,2.23,0,3.34,1.34,3.34,4.03v6.1Z" />
				<path d="m525.87,731.91l-2.49,8.81h-1.21l-1.81-6.44c-.08-.27-.12-.57-.14-.9h-.02c-.02.3-.08.6-.16.89l-1.83,6.45h-1.2l-2.58-8.81h1.14l1.87,6.76c.08.28.13.58.15.89h.03c.02-.22.08-.51.19-.89l1.95-6.76h.99l1.87,6.81c.07.23.11.51.15.82h.02c.02-.21.07-.5.17-.85l1.8-6.79h1.12Z" />
				<polygon points="531.01 731.91 526.78 742.19 525.84 742.19 530.06 731.91 531.01 731.91" />
				<path d="m532.04,740.72v-8.81h2.43c3.11,0,4.66,1.43,4.66,4.3,0,1.36-.43,2.45-1.3,3.28-.86.82-2.01,1.24-3.46,1.24h-2.34Zm1.03-7.88v6.95h1.32c1.16,0,2.06-.31,2.7-.93.64-.62.97-1.5.97-2.63,0-2.26-1.2-3.39-3.6-3.39h-1.38Z" />
			</g>
		</g>
	)
}

export default PlanM
